<!-- This file is generated by /scripts/generate-icons.ts -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <symbol viewBox="0 0 24 24" id="access-time" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="account-alert" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 4a4 4 0 014 4 4 4 0 01-4 4 4 4 0 01-4-4 4 4 0 014-4m0 10c4.42 0 8 1.79 8 4v2H2v-2c0-2.21 3.58-4 8-4m10-2V7h2v5h-2m0 4v-2h2v2h-2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="account-box" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 5v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5a2 2 0 00-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="account-box-outline" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 19H5V5h14m0-2H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2m-2.5 13.25c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9M12 12.25A2.25 2.25 0 0014.25 10 2.25 2.25 0 0012 7.75 2.25 2.25 0 009.75 10 2.25 2.25 0 0012 12.25z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="account-check">
    <path
      d="M9 5a3.5 3.5 0 013.5 3.5A3.5 3.5 0 019 12a3.5 3.5 0 01-3.5-3.5A3.5 3.5 0 019 5m0 8.75c3.87 0 7 1.57 7 3.5V19H2v-1.75c0-1.93 3.13-3.5 7-3.5m8-1.09l-2.75-3 1.16-1.16L17 10.09l3.59-3.59 1.16 1.41L17 12.66z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="account-clock" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.63 14.1a6.998 6.998 0 019.27-3.47 6.998 6.998 0 013.47 9.27A6.98 6.98 0 0117 24c-2.7 0-5.17-1.56-6.33-4H1v-2c.06-1.14.84-2.07 2.34-2.82S6.72 14.04 9 14c.57 0 1.11.05 1.63.1M9 4c1.12.03 2.06.42 2.81 1.17S12.93 6.86 12.93 8c0 1.14-.37 2.08-1.12 2.83-.75.75-1.69 1.12-2.81 1.12s-2.06-.37-2.81-1.12C5.44 10.08 5.07 9.14 5.07 8c0-1.14.37-2.08 1.12-2.83C6.94 4.42 7.88 4.03 9 4m8 18a5 5 0 005-5 5 5 0 00-5-5 5 5 0 00-5 5 5 5 0 005 5m-1-8h1.5v2.82l2.44 1.41-.75 1.3L16 17.69V14z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="account-group">
    <path
      d="M12 6a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3M6 8.17a2.5 2.5 0 00-2.5 2.5 2.5 2.5 0 002.5 2.5c.88 0 1.65-.46 2.09-1.14C7.42 11.18 7 10.15 7 9c0-.2 0-.4.04-.6-.32-.15-.67-.23-1.04-.23m12 0c-.37 0-.72.08-1.04.23.04.2.04.4.04.6 0 1.15-.42 2.18-1.09 3.03A2.49 2.49 0 0018 13.17a2.5 2.5 0 002.5-2.5 2.5 2.5 0 00-2.5-2.5M12 14c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3m-7.33.97C3 15.26 1 16.04 1 17.33V19h3v-2c0-.78.29-1.47.67-2.03m14.66 0c.38.56.67 1.25.67 2.03v2h3v-1.67c0-1.29-2-2.07-3.67-2.36z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="account-plus" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 14c-2.67 0-8 1.33-8 4v2h16v-2c0-2.67-5.33-4-8-4m-9-4V7H4v3H1v2h3v3h2v-3h3v-2m6 2a4 4 0 004-4 4 4 0 00-4-4 4 4 0 00-4 4 4 4 0 004 4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="account-search" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.5 3A6.5 6.5 0 0116 9.5c0 1.61-.59 3.09-1.57 4.23l.28.27h.79l5 5-1.5 1.5-5-5v-.79l-.27-.28A6.471 6.471 0 019.5 16 6.5 6.5 0 013 9.5 6.5 6.5 0 019.5 3m0 11c1.61 0 3-.85 3.82-2.12C12.5 10.75 11.11 10 9.5 10c-1.61 0-3 .75-3.82 1.88C6.5 13.15 7.89 14 9.5 14m0-9a1.75 1.75 0 00-1.75 1.75A1.75 1.75 0 009.5 8.5a1.75 1.75 0 001.75-1.75A1.75 1.75 0 009.5 5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="add" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
  </symbol>
  <symbol viewBox="0 0 16 16" id="add-reaction" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.556 6.222V4.89h-1.334V2.116A6.663 6.663 0 00.89 8.223c0 3.68 2.98 6.666 6.66 6.666a6.67 6.67 0 006.673-6.667c0-.7-.113-1.366-.313-2h-2.353zm-1.667-.666c.553 0 1 .446 1 1 0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.554.447-1 1-1zm-4.667 0c.554 0 1 .446 1 1 0 .553-.446 1-1 1-.553 0-1-.447-1-1 0-.554.447-1 1-1zm2.334 6.333a3.664 3.664 0 01-3.407-2.333h6.813a3.664 3.664 0 01-3.406 2.333zm6.666-9.667h1.334v1.334h-1.334v1.333H12.89V3.556h-1.333V2.222h1.333V.89h1.333v1.333z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="alarm" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="alternate-email" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
    />
  </symbol>
  <symbol viewBox="0 0 29 19" id="amex" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path
        d="M27 0H2C.816 0 0 .814 0 2v15c0 1.186.816 2 2 2h25c1.184 0 2-.814 2-2V2c0-1.186-.816-2-2-2z"
        fill="#0074B5"
      />
      <path
        d="M6.09 10.273h1.455l-.727-1.818-.727 1.818zm20.274-3.455h-3.728l-.909 1-.818-1H13l-.727 1.637-.728-1.637H8.364v.727L8 6.818H5.273l-2.637 6.364h3.182l.364-1h.909l.364 1H11v-.727l.273.727h1.818l.273-.818v.818h7.272l.91-1 .818 1h3.727L23.727 10l2.637-3.182zm-11 5.455h-1V8.727l-1.546 3.546h-.909l-1.545-3.546v3.546H8.273l-.364-1H5.727l-.363 1H4.182L6.09 7.727h1.545L9.364 12V7.727h1.727l1.364 3.091 1.272-3.09h1.728v4.545h-.091zm9 0H23l-1.182-1.546-1.363 1.546h-4.091V7.727h4.181l1.273 1.455 1.364-1.455h1.273l-2 2.273 1.909 2.273zm-7-3.637v.819h2.272v.909h-2.272v.909h2.545l1.182-1.364L20 8.636h-2.636z"
        fill="#FFF"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="angellist" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.465 9.954c.735-2 1.31-3.65 1.723-4.954.41-1.3.618-2.1.618-2.4 0-.315-.07-.564-.21-.738a.679.679 0 00-.567-.264c-.31 0-.63.255-.94.765-.32.51-.67 1.334-1.06 2.467l-1.65 4.76 2.08.362h-.01v.002zm-2.193 4.435c-.474-.03-.923-.08-1.344-.15-.42-.08-.83-.19-1.216-.33.177.35.335.7.472 1.05.138.35.25.69.34 1.04.26-.33.54-.63.83-.9.292-.27.6-.51.915-.72zm-1.862-5l-1.78-5.14c-.464-1.31-.82-2.16-1.075-2.57-.25-.4-.525-.6-.822-.6-.23 0-.417.08-.56.26-.144.18-.214.41-.214.7 0 .5.19 1.38.57 2.64.38 1.25.96 2.89 1.73 4.93.06-.12.16-.21.28-.26.12-.05.28-.08.49-.08.06 0 .19.01.39.01.19.02.52.04.97.09zm-1.618 7.96c.188 0 .36-.09.51-.26.15-.18.234-.36.234-.55 0-.21-.15-.7-.452-1.46-.3-.76-.68-1.51-1.13-2.25-.33-.55-.655-.97-.97-1.25-.324-.28-.625-.42-.91-.42-.23 0-.484.14-.767.44-.28.29-.42.56-.42.81 0 .26.14.66.413 1.18.275.53.645 1.09 1.104 1.68.485.65.94 1.15 1.37 1.51.428.36.77.54 1.02.54h-.002zm-4.945-.4c.156.19.37.46.646.82.723 1 1.395 1.5 2.01 1.5.21 0 .397-.07.563-.2.164-.14.247-.27.247-.42 0-.17-.11-.44-.33-.83a10.35 10.35 0 00-.907-1.3c-.44-.56-.805-.97-1.098-1.23-.288-.26-.525-.39-.697-.39-.38 0-.74.21-1.06.62-.32.4-.48.9-.48 1.46 0 .45.12.95.35 1.51.23.55.55 1.11.98 1.67a6.59 6.59 0 002.42 2c.96.46 2.03.69 3.19.69 2.14 0 3.94-.8 5.38-2.4 1.45-1.6 2.17-3.6 2.17-6.01 0-.74-.05-1.33-.16-1.76-.11-.43-.29-.75-.54-.95-.45-.38-1.33-.71-2.63-1.01-1.3-.3-2.66-.45-4.08-.45-.39 0-.68.07-.84.2-.16.13-.24.36-.24.673 0 .75.42 1.29 1.26 1.626.84.34 2.19.51 4.06.51h.676c.15 0 .28.06.37.174.09.11.15.28.18.52-.19.17-.57.37-1.154.6-.59.22-1.03.45-1.34.665a5.912 5.912 0 00-1.59 1.724c-.4.66-.6 1.29-.6 1.883 0 .36.086.8.258 1.31.17.51.26.823.26.95v.11l-.03.15c-.48-.03-.86-.313-1.14-.85-.287-.53-.42-1.24-.42-2.13v-.15a.91.91 0 01-.26.165.734.734 0 01-.27.05c-.1 0-.198-.006-.29-.02-.09-.016-.18-.04-.29-.075.03.12.057.24.076.353.01.12.02.21.02.27 0 .406-.16.76-.48 1.05-.32.287-.7.43-1.14.43-.69 0-1.397-.34-2.11-1.01-.715-.674-1.07-1.34-1.07-1.985 0-.12.015-.23.04-.323s.075-.17.14-.24zm11.807-6.73c.985.18 1.685.6 2.09 1.25.41.64.61 1.66.61 3.06 0 2.77-.828 5.03-2.492 6.79-1.667 1.76-3.797 2.65-6.387 2.65a8.216 8.216 0 01-2.976-.56c-.97-.37-1.79-.89-2.49-1.54-.79-.73-1.39-1.49-1.78-2.3-.4-.81-.6-1.64-.6-2.48 0-.95.2-1.68.6-2.19.4-.52 1.05-.87 1.93-1.06-.17-.39-.29-.71-.36-.98-.08-.27-.12-.47-.12-.61 0-.5.26-1.01.78-1.52.52-.52 1.01-.78 1.47-.78.19 0 .4.03.62.11.22.07.47.19.75.35-.81-2.35-1.43-4.2-1.81-5.5-.39-1.31-.58-2.2-.58-2.7 0-.68.17-1.23.52-1.63.36-.4.84-.6 1.44-.6 1.03 0 2.34 2.31 3.93 6.923.28.79.48 1.4.63 1.83l.51-1.453c1.59-4.55 2.95-6.83 4.1-6.83.56 0 1.01.19 1.34.57.33.383.5.887.5 1.523 0 .48-.19 1.36-.56 2.65-.367 1.28-.92 2.96-1.67 5.04"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="archive" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="arrow-back" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="arrow-drop-down" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 10l5 5 5-5z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="arrow-drop-up" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 14l5-5 5 5z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="arrow-forward" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="assignment" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="assignment-turned-in" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="attach-file" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 015 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 005 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="automated-actions" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <path
        id="axa"
        d="M5 1h6L9 6h4.89a1 1 0 01.774 1.633L7 17l2-7H4.247a1 1 0 01-.977-1.217L5 1z"
      />
    </defs>
    <use fill-rule="evenodd" xlink:href="#axa" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="autorenew" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 016 12c0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="behance" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.938 4.503c.702 0 1.34.06 1.92.188.577.13 1.07.33 1.485.61.41.28.733.65.96 1.12.225.47.34 1.05.34 1.73 0 .74-.17 1.36-.507 1.86-.338.5-.837.9-1.502 1.22.906.26 1.576.72 2.022 1.37.448.66.665 1.45.665 2.36 0 .75-.13 1.39-.41 1.93-.28.55-.67 1-1.16 1.35-.48.348-1.05.6-1.67.767a7.316 7.316 0 01-1.91.254H0V4.51h6.938v-.007zM16.94 16.665c.44.428 1.073.643 1.894.643.59 0 1.1-.148 1.53-.447.424-.29.68-.61.78-.94h2.588c-.403 1.28-1.048 2.2-1.9 2.75-.85.56-1.884.83-3.08.83-.837 0-1.584-.13-2.272-.4a4.948 4.948 0 01-1.72-1.14 5.1 5.1 0 01-1.077-1.77c-.253-.69-.373-1.45-.373-2.27 0-.803.135-1.54.403-2.23.27-.7.644-1.28 1.12-1.79.495-.51 1.063-.895 1.736-1.194s1.4-.433 2.22-.433c.91 0 1.69.164 2.38.523a4.8 4.8 0 011.66 1.4c.44.586.75 1.26.94 2.02.19.75.25 1.54.21 2.38h-7.69c0 .84.28 1.632.71 2.065l-.08.03zm-10.24.05c.317 0 .62-.03.906-.093.29-.06.548-.165.763-.3.21-.135.39-.328.52-.583.13-.24.19-.57.19-.96 0-.75-.22-1.29-.64-1.62-.43-.32-.99-.48-1.69-.48H3.24v4.05H6.7v-.03zm13.607-5.65c-.352-.385-.94-.592-1.657-.592-.468 0-.855.074-1.166.238-.302.15-.55.35-.74.59-.19.24-.317.48-.392.75-.075.26-.12.5-.135.71h4.762c-.07-.75-.33-1.3-.68-1.69v.01zM6.52 10.45c.574 0 1.05-.134 1.425-.412.374-.27.554-.72.554-1.338 0-.344-.07-.625-.18-.846-.13-.22-.3-.39-.5-.512-.21-.124-.45-.21-.72-.257a4.426 4.426 0 00-.84-.074H3.23v3.44h3.29zm9.098-4.958h5.968v1.454h-5.968V5.48v.01z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="block" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 014 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0120 12c0 4.42-3.58 8-8 8z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="book-open-page-variant" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 2l-5 4.5v11l5-4.5V2M6.5 5C4.55 5 2.45 5.4 1 6.5v14.66c0 .25.25.5.5.5.1 0 .15-.07.25-.07 1.35-.65 3.3-1.09 4.75-1.09 1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.31 4.75 1.06.1.05.15.03.25.03.25 0 .5-.25.5-.5V6.5c-.6-.45-1.25-.75-2-1V19c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V6.5C10.55 5.4 8.45 5 6.5 5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="bookmark" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="bookmark-border" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="border-color" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96a.996.996 0 000-1.41L18.37.29a.996.996 0 00-1.41 0L15 2.25 18.75 6l1.96-1.96z"
    />
    <path fill-opacity=".36" d="M0 20h24v4H0z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="broken-image" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="brush" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34a.996.996 0 00-1.41 0L9 12.25 11.75 15l8.96-8.96a.996.996 0 000-1.41z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="bullhorn" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 12v4a1 1 0 01-1 1c-.17 0-.33 0-.94-.5-.62-.5-1.67-1.5-2.75-2-1-.46-2.03-.5-3.05-.5l1.21 3.32.03.18a.5.5 0 01-.5.5H7c-.22 0-.41-.14-.47-.34L5.19 14H5a1 1 0 01-1-1 2 2 0 01-2-2 2 2 0 012-2 1 1 0 011-1h3c1.11 0 2.22 0 3.31-.5 1.08-.5 2.13-1.5 2.75-2 .61-.5.77-.5.94-.5a1 1 0 011 1v4a1 1 0 011 1 1 1 0 01-1 1m5-1c0 1.38-.56 2.63-1.46 3.54l-1.42-1.42a2.993 2.993 0 000-4.24l1.42-1.42C20.44 8.37 21 9.62 21 11z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="calendar-blank" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2h-1V1"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="calendar-clock" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 13h1.5v2.82l2.44 1.41-.75 1.3L15 16.69V13m4-5H5v11h4.67c-.43-.91-.67-1.93-.67-3a7 7 0 017-7c1.07 0 2.09.24 3 .67V8M5 21a2 2 0 01-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 012 2v6.1c1.24 1.26 2 2.99 2 4.9a7 7 0 01-7 7c-1.91 0-3.64-.76-4.9-2H5m11-9.85A4.85 4.85 0 0011.15 16c0 2.68 2.17 4.85 4.85 4.85A4.85 4.85 0 0020.85 16c0-2.68-2.17-4.85-4.85-4.85z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="calendar-plus" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 19V7H5v12h14M16 1h2v2h1a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1m-5 8h2v3h3v2h-3v3h-2v-3H8v-2h3V9z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="calendar-today" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 10h5v5H7m12 4H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="call" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="call-made" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="call-received" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="call-split" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="camcorder" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 10.5V7a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h12a1 1 0 001-1v-3.5l4 4v-11l-4 4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="cancel" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2a10 10 0 0110 10 10 10 0 01-10 10A10 10 0 012 12 10 10 0 0112 2m0 2a8 8 0 00-8 8c0 1.85.63 3.55 1.68 4.91L16.91 5.68A8.005 8.005 0 0012 4m0 16a8 8 0 008-8c0-1.85-.63-3.55-1.68-4.91L7.09 18.32A8.005 8.005 0 0012 20z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="cash" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 6h18v12H3V6m9 3a3 3 0 013 3 3 3 0 01-3 3 3 3 0 01-3-3 3 3 0 013-3M7 8a2 2 0 01-2 2v4a2 2 0 012 2h10a2 2 0 012-2v-4a2 2 0 01-2-2H7z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="chart-bar" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 21H2V3h2v16h2v-9h4v9h2V6h4v13h2v-5h4v7z" />
  </symbol>
  <symbol viewBox="0 0 18 18" id="chart-bar-broken" xmlns="http://www.w3.org/2000/svg">
    <g fill="#4D6072" fill-rule="evenodd">
      <path
        d="M1.5 4.328l1.5 1.5v8.422h1.5V7.5h.172L7.5 10.328v3.922H9v-2.422l3.922 3.922H1.5V4.328zm15 6.172v3.172l-3-3V10.5h3zm-4.5-6v4.672l-3-3V4.5h3z"
        fill-opacity=".5"
      />
      <path d="M4.414 3L17 15.586V16h-2.415l-13-13h2.829z" />
    </g>
  </symbol>
  <symbol viewBox="0 0 60 60" id="chart-icon_bar" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(8 8)" fill="none" fill-rule="evenodd">
      <rect fill="#98B1BD" y="36" width="8" height="8" rx="2" />
      <rect fill="#4D6072" y="24" width="20" height="8" rx="2" />
      <rect fill="#083F5E" y="12" width="32" height="8" rx="2" />
      <rect fill="#1999E3" width="44" height="8" rx="2" />
    </g>
  </symbol>
  <symbol viewBox="0 0 60 60" id="chart-icon_bar-stacked" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <rect id="bwa" x="0" y="0" width="20" height="8" rx="2" />
      <rect id="bwc" x="0" y="0" width="32" height="8" rx="2" />
      <rect id="bwe" x="0" y="0" width="44" height="8" rx="2" />
    </defs>
    <g transform="translate(8 8)" fill="none" fill-rule="evenodd">
      <rect fill="#98B1BD" y="36" width="8" height="8" rx="2" />
      <g transform="translate(0 24)">
        <mask id="bwb" fill="#fff"><use xlink:href="#bwa" /></mask>
        <use fill="#98B1BD" xlink:href="#bwa" />
        <path fill="#4D6072" mask="url(#bwb)" d="M0 0h13v8H0z" />
      </g>
      <g transform="translate(0 12)">
        <mask id="bwd" fill="#fff"><use xlink:href="#bwc" /></mask>
        <use fill="#C9D7DF" xlink:href="#bwc" />
        <path fill="#4D6072" mask="url(#bwd)" d="M0 0h8v8H0z" />
        <path fill="#98B1BD" mask="url(#bwd)" d="M8 0h15v8H8z" />
      </g>
      <mask id="bwf" fill="#fff"><use xlink:href="#bwe" /></mask>
      <use fill="#1999E3" xlink:href="#bwe" />
      <path fill="#083F5E" mask="url(#bwf)" d="M0 0h17v8H0z" />
      <path fill="#0C6090" mask="url(#bwf)" d="M17 0h11v8H17z" />
    </g>
  </symbol>
  <symbol viewBox="0 0 60 60" id="chart-icon_column" xmlns="http://www.w3.org/2000/svg">
    <g transform="rotate(-90 30 22)" fill="none" fill-rule="evenodd">
      <rect fill="#98B1BD" y="36" width="8" height="8" rx="2" />
      <rect fill="#4D6072" y="24" width="20" height="8" rx="2" />
      <rect fill="#083F5E" y="12" width="32" height="8" rx="2" />
      <rect fill="#1999E3" width="44" height="8" rx="2" />
    </g>
  </symbol>
  <symbol viewBox="0 0 60 60" id="chart-icon_column-multi" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <path d="M0 6h17v4a2 2 0 01-2 2H2a2 2 0 01-2-2V6z" id="bya" />
      <path d="M0 6h11v4a2 2 0 01-2 2H2a2 2 0 01-2-2V6z" id="byb" />
      <path d="M0 6h24v4a2 2 0 01-2 2H2a2 2 0 01-2-2V6z" id="byc" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g transform="rotate(-90 46 6)">
        <path d="M2 0h18a2 2 0 012 2v2a2 2 0 01-2 2H0V2a2 2 0 012-2z" fill="#98B1BD" />
        <use fill="#4D6072" xlink:href="#bya" />
      </g>
      <g transform="rotate(-90 38 14)">
        <path d="M2 0h28a2 2 0 012 2v2a2 2 0 01-2 2H0V2a2 2 0 012-2z" fill="#98B1BD" />
        <use fill="#4D6072" xlink:href="#byb" />
      </g>
      <g transform="rotate(-90 30 22)">
        <path d="M2 0h40a2 2 0 012 2v2a2 2 0 01-2 2H0V2a2 2 0 012-2z" fill="#1999E3" />
        <use fill="#083F5E" xlink:href="#byc" />
      </g>
    </g>
  </symbol>
  <symbol viewBox="0 0 60 60" id="chart-icon_column-stacked" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <rect id="bza" x="0" y="0" width="20" height="8" rx="2" />
      <rect id="bzc" x="0" y="0" width="32" height="8" rx="2" />
      <rect id="bze" x="0" y="0" width="44" height="8" rx="2" />
    </defs>
    <g transform="rotate(-90 30 22)" fill="none" fill-rule="evenodd">
      <rect fill="#98B1BD" y="36" width="8" height="8" rx="2" />
      <g transform="translate(0 24)">
        <mask id="bzb" fill="#fff"><use xlink:href="#bza" /></mask>
        <use fill="#98B1BD" xlink:href="#bza" />
        <path fill="#4D6072" mask="url(#bzb)" d="M0 0h13v8H0z" />
      </g>
      <g transform="translate(0 12)">
        <mask id="bzd" fill="#fff"><use xlink:href="#bzc" /></mask>
        <use fill="#C9D7DF" xlink:href="#bzc" />
        <path fill="#4D6072" mask="url(#bzd)" d="M0 0h8v8H0z" />
        <path fill="#98B1BD" mask="url(#bzd)" d="M8 0h15v8H8z" />
      </g>
      <mask id="bzf" fill="#fff"><use xlink:href="#bze" /></mask>
      <use fill="#1999E3" xlink:href="#bze" />
      <path fill="#083F5E" mask="url(#bzf)" d="M0 0h17v8H0z" />
      <path fill="#0C6090" mask="url(#bzf)" d="M17 0h11v8H17z" />
    </g>
  </symbol>
  <symbol viewBox="0 0 60 60" id="chart-icon_line" xmlns="http://www.w3.org/2000/svg">
    <g
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="4"
    >
      <path stroke="#1999E3" d="M8 52l16.203-17.633 10.93 11.721L52 28" />
      <path stroke="#083F5E" d="M8 38l27.133-28L52 13.99" />
    </g>
  </symbol>
  <symbol viewBox="0 0 60 60" id="chart-icon_pie" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero" fill="none">
      <path
        d="M28.953 30.653L40 49.68A22.136 22.136 0 0130.154 52C17.919 52 8 42.134 8 29.965 8 18.26 17.184 8.713 28.77 8v21.965c0 .237.062.474.189.688h-.006z"
        fill="#1999E3"
      />
      <path d="M52 29H31V8c11.287.698 20.3 9.708 21 21z" fill="#98B1BD" />
      <path d="M42.01 48c5.696-3.713 9.54-9.906 9.99-17H32l10.01 17z" fill="#083F5E" />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="chat" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="chat-bubble-outline" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="check" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="check-box-outline-blank" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="checklist" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 7h-9v2h9V7zm0 8h-9v2h9v-2zM5.54 11L2 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 11zm0 8L2 15.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 19z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="chevron-left" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="chevron-right" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="clear" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="clear-all" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="clock" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 20a8 8 0 008-8 8 8 0 00-8-8 8 8 0 00-8 8 8 8 0 008 8m0-18a10 10 0 0110 10 10 10 0 01-10 10C6.47 22 2 17.5 2 12A10 10 0 0112 2m.5 5v5.25l4.5 2.67-.75 1.23L11 13V7h1.5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="close" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="cloud" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="cloud-upload" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="code" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="comment" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="comment-account" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 22a1 1 0 01-1-1v-3H4a2 2 0 01-2-2V4a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m7-8v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1h8m-4-8a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="content-copy" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="credit-card" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="dashboard" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="delete" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="delete-forever" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="description" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
    />
  </symbol>
  <symbol viewBox="0 0 29 19" id="dinners" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <path
        d="M27 0H2C.816 0 0 .814 0 2v15c0 1.186.816 2 2 2h25c1.184 0 2-.814 2-2V2c0-1.186-.816-2-2-2z"
        id="cya"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <mask id="cyb" fill="#fff"><use xlink:href="#cya" /></mask>
      <use fill="#FFF" xlink:href="#cya" />
      <path
        stroke="#C9D7DF"
        d="M27 .5H2C1.091.5.5 1.091.5 2v15c0 .909.591 1.5 1.5 1.5h25c.909 0 1.5-.591 1.5-1.5V2c0-.909-.591-1.5-1.5-1.5z"
      />
      <g mask="url(#cyb)" fill-rule="nonzero">
        <path
          d="M15.426 15.507c3.143.015 6.013-2.563 6.013-5.7 0-3.43-2.87-5.8-6.013-5.8H12.72c-3.18 0-5.799 2.37-5.799 5.8 0 3.137 2.619 5.715 5.8 5.7h2.705z"
          fill="#0064A7"
        />
        <path
          d="M13.927 12.861V6.633a3.34 3.34 0 012.143 3.114 3.34 3.34 0 01-2.143 3.114m-4.53-3.114a3.342 3.342 0 012.142-3.114v6.227a3.34 3.34 0 01-2.142-3.113m3.336-5.264a5.264 5.264 0 10.003 10.528 5.264 5.264 0 00-.003-10.528"
          fill="#FFF"
        />
      </g>
    </g>
  </symbol>
  <symbol viewBox="0 0 29 19" id="discover" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <path
        d="M27 0H2C.816 0 0 .814 0 2v15c0 1.186.816 2 2 2h25c1.184 0 2-.814 2-2V2c0-1.186-.816-2-2-2z"
        id="cza"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <mask id="czb" fill="#fff"><use xlink:href="#cza" /></mask>
      <use fill="#F0F4F7" xlink:href="#cza" />
      <path
        d="M29.538 11.578l-.007.005-.04.025-.224.147-.006.004-.219.14a42.78 42.78 0 01-3.615 2.031c-2.857 1.446-5.814 2.65-8.845 3.678a76.806 76.806 0 01-7.073 2.036c-1.232.29-2.474.542-3.713.802-.18.037-.36.07-.54.103l-.017.006-1.946.44H27.59a2.2 2.2 0 002.2-2.199v-7.38l-.25.162z"
        fill="#FF6F00"
        fill-rule="nonzero"
        mask="url(#czb)"
      />
      <g mask="url(#czb)" fill-rule="nonzero">
        <path
          d="M3.232 10.8V7.266c.014-.004.026-.01.039-.01.392.003.785-.012 1.175.014.625.043 1.15.297 1.467.86.626 1.108-.057 2.494-1.295 2.64-.312.037-.629.023-.944.03-.144.003-.289 0-.442 0zm.695-.607c.131 0 .255.006.377-.002.273-.017.53-.082.742-.27.487-.433.515-1.253.06-1.722-.329-.34-.748-.347-1.179-.337v2.33zM22.84 7.263c.013-.003.021-.007.029-.006.391.002.783-.001 1.175.012.137.005.277.038.408.08.447.147.694.53.665 1-.017.268-.085.512-.286.704-.125.119-.274.19-.436.236l-.081.023 1.112 1.488h-.467c-.104 0-.209-.003-.313.001-.056.003-.088-.019-.118-.065l-.869-1.297c-.029-.044-.056-.081-.127-.053v1.408h-.692v-3.53zm.693 1.625c.217 0 .43.014.627-.095.18-.1.244-.264.242-.461-.002-.19-.074-.342-.249-.431-.196-.1-.407-.087-.62-.08v1.067zM20.428 7.26h1.947v.597h-1.253v.784h1.204v.603h-1.205v.95h1.257v.599h-1.95V7.26zM9.739 7.597l-.36.47c-.133-.141-.273-.255-.463-.28-.19-.023-.368.008-.509.149-.152.152-.135.38.048.493.122.076.26.126.391.187.2.094.407.176.6.285.276.158.401.413.414.73.017.418-.11.772-.457 1.026-.262.19-.563.244-.881.225-.484-.028-.84-.268-1.097-.654l.416-.444c.087.1.156.2.245.277a.74.74 0 00.691.165.479.479 0 00.361-.563.403.403 0 00-.218-.284c-.13-.065-.266-.115-.399-.171-.144-.061-.29-.115-.43-.184-.446-.222-.583-.609-.456-1.092.107-.403.475-.686.931-.726.43-.038.812.085 1.145.36.008.007.014.016.028.03zM16.714 7.256c.242 0 .477-.002.712.003.022 0 .052.042.063.07.245.61.487 1.222.73 1.832l.185.464.04-.088.887-2.21c.02-.05.042-.074.1-.073.222.004.444.002.678.002-.013.035-.022.062-.033.088-.488 1.159-.977 2.317-1.463 3.475-.023.056-.05.075-.108.071-.08-.004-.16.003-.239-.003-.027-.002-.068-.025-.078-.049-.491-1.18-.98-2.362-1.468-3.543-.003-.007-.003-.016-.006-.039zM12.814 8.197c-.11-.083-.206-.167-.312-.232a1.105 1.105 0 00-1.312.138c-.554.494-.529 1.457.05 1.903.435.334 1.04.317 1.455-.042l.12-.104v.751c.001.044-.013.068-.054.088-.846.403-1.882.128-2.385-.65a1.852 1.852 0 011.188-2.83 1.746 1.746 0 011.19.149c.026.012.058.042.058.065.004.251.002.503.002.764z"
          fill="#303030"
        />
        <path
          d="M16.833 9.03c.017 1.014-.818 1.842-1.875 1.84-1.065 0-1.883-.794-1.876-1.86.005-1.008.834-1.803 1.877-1.81 1.062-.006 1.89.83 1.874 1.83z"
          fill="#FF6F00"
        />
        <path d="M7.151 10.796H6.47V7.262h.682v3.534z" fill="#303030" />
      </g>
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="domain" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 15h-2v2h2m0-6h-2v2h2m2 6h-8v-2h2v-2h-2v-2h2v-2h-2V9h8M10 7H8V5h2m0 6H8V9h2m0 6H8v-2h2m0 6H8v-2h2M6 7H4V5h2m0 6H4V9h2m0 6H4v-2h2m0 6H4v-2h2m6-10V3H2v18h20V7H12z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="done" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="done-all" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
    />
  </symbol>
  <symbol viewBox="0 0 12 12" id="dot" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="4" r="4" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="drag-handle" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="drag-vertical" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0h2.667v2.667H8V0m5.333 0H16v2.667h-2.667V0M8 5.333h2.667V8H8V5.333m5.333 0H16V8h-2.667V5.333M8 10.667h2.667v2.666H8v-2.666m5.333 0H16v2.666h-2.667v-2.666M8 16h2.667v2.667H8V16m5.333 0H16v2.667h-2.667V16M8 21.333h2.667V24H8v-2.667m5.333 0H16V24h-2.667v-2.667z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="dribbble" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 24C5.385 24 0 18.615 0 12S5.385 0 12 0s12 5.385 12 12-5.385 12-12 12zm10.12-10.358c-.35-.11-3.17-.953-6.384-.438 1.34 3.684 1.887 6.684 1.992 7.308a10.28 10.28 0 004.395-6.87zm-6.115 7.808c-.153-.9-.75-4.032-2.19-7.77l-.066.02c-5.79 2.015-7.86 6.025-8.04 6.4a10.161 10.161 0 006.29 2.166c1.42 0 2.77-.29 4-.814zm-11.62-2.58c.232-.4 3.045-5.055 8.332-6.765.135-.045.27-.084.405-.12-.26-.585-.54-1.167-.832-1.74C7.17 11.775 2.206 11.71 1.756 11.7l-.004.312c0 2.633.998 5.037 2.634 6.855zm-2.42-8.955c.46.008 4.683.026 9.477-1.248a65.473 65.473 0 00-3.8-5.928 10.275 10.275 0 00-5.676 7.17zM9.6 2.052c.282.38 2.145 2.914 3.822 6 3.645-1.365 5.19-3.44 5.373-3.702A10.19 10.19 0 0012 1.764c-.825 0-1.63.1-2.4.285zm10.335 3.483c-.218.29-1.935 2.493-5.724 4.04.24.49.47.985.68 1.486.08.18.15.36.22.53 3.41-.43 6.8.26 7.14.33-.02-2.42-.88-4.64-2.31-6.38z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="edit" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
    />
  </symbol>
  <symbol viewBox="0 0 18 16" id="edu" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 1L0 6.333l3.273 1.938v5.333L9 17l5.727-3.396V8.271l1.637-.969v6.142H18v-7.11L9 1zm3.96 12.03L9 15.4l-3.96-2.37V9.8L9 12.17l3.96-2.37v3.23z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="email" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="error" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="error-outline" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="event" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="expand-less" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="expand-more" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="extension" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5a2.5 2.5 0 00-5 0V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5a2.5 2.5 0 000-5z"
    />
  </symbol>
  <symbol viewBox="0 0 1792 1792" id="fa-caret-right" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1152 896q0 26-19 45l-448 448q-19 19-45 19t-45-19-19-45V448q0-26 19-45t45-19 45 19l448 448q19 19 19 45z"
    />
  </symbol>
  <symbol viewBox="0 0 1792 1792" id="fa-suitcase" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M640 384h512V256H640v128zm-352 0v1280h-64q-92 0-158-66T0 1440V608q0-92 66-158t158-66h64zm1120 0v1280H384V384h128V224q0-40 28-68t68-28h576q40 0 68 28t28 68v160h128zm384 224v832q0 92-66 158t-158 66h-64V384h64q92 0 158 66t66 158z"
    />
  </symbol>
  <symbol
    style="width: 24px; height: 24px"
    viewBox="0 0 24 24"
    id="facebook"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17 2v4h-2c-.69 0-1 .81-1 1.5V10h3v4h-3v8h-4v-8H7v-4h3V6a4 4 0 014-4h3z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="favorite" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="favorite-border" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="file-account" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.11.89-2 2-2m8 18v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1h8m-4-8a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="file-document" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.11.89-2 2-2m9 16v-2H6v2h9m3-4v-2H6v2h12z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="file-download" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="file-export" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6m-1 1.5L18.5 9H13m-4.07 3.22H16v7.07l-2.12-2.12L11.05 20l-2.83-2.83 2.83-2.82"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="file-upload" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="filter-add" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 12v7.88c.04.3-.06.62-.29.83a.996.996 0 01-1.41 0L8.29 18.7a.989.989 0 01-.29-.83V12h-.03L2.21 4.62a1 1 0 01.17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 01.17 1.4L12.03 12H12m3 5h3v-3h2v3h3v2h-3v3h-2v-3h-3v-2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="filter-list" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="find-in-page" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="flag" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="folder" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="folder-open" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="format-align-left" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="format-bold" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="format-color-text" xmlns="http://www.w3.org/2000/svg">
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M2 20h20v4H2v-4zm3.49-3h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5L5.49 17zm4.42-5.61l2.03-5.79h.12l2.03 5.79H9.91z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="format-ital" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="format-list-bulleted" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="format-list-checks" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 5h6v6H3V5m2 2v2h2V7H5m6 0h10v2H11V7m0 8h10v2H11v-2m-6 5l-3.5-3.5 1.41-1.41L5 17.17l4.59-4.58L11 14l-6 6z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="format-list-numbered" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="format-strikethrough" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="format-underlined" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="forum" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="forward" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 8V4l8 8-8 8v-4H4V8z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="fullscreen" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
  </symbol>
  <symbol viewBox="0 0 18 18" id="gdpr-candidate" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 .75l-6.75 3v4.5c0 4.162 2.88 8.055 6.75 9 3.87-.945 6.75-4.838 6.75-9v-4.5L9 .75m0 3a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5m3.848 9A7.267 7.267 0 019 15.69a7.267 7.267 0 01-3.848-2.94 7.624 7.624 0 01-.652-1.148c0-1.237 2.032-2.25 4.5-2.25 2.467 0 4.5.99 4.5 2.25-.18.398-.398.773-.652 1.148z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="github" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="google" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="google-calendar" xmlns="http://www.w3.org/2000/svg">
    <g stroke="null">
      <path
        fill="#E6E6E6"
        d="M21.095.886h-18.1c-.564 0-1.02.458-1.02 1.022v3.396h20.141V1.908c0-.564-.457-1.022-1.021-1.022zM7.156 2.93a.49.49 0 110-.979.49.49 0 010 .979zm9.906 0a.49.49 0 110-.979.49.49 0 010 .979z"
      />
      <path
        fill="#3A5BBC"
        d="M23.583 5.54l-1.545 8.057.631 8.377a1.06 1.06 0 01-1.057 1.14H2.387a1.06 1.06 0 01-1.057-1.14l.632-8.377L.417 5.541a1.23 1.23 0 011.207-1.46h20.751a1.23 1.23 0 011.208 1.46z"
      />
      <path
        fill="#518EF8"
        d="M21.657 23.114H2.433a1.06 1.06 0 01-1.058-1.14l.632-8.377H22.084l.63 8.377a1.06 1.06 0 01-1.057 1.14z"
      />
      <g fill="#FFF">
        <path
          d="M11.654 11.495c0-1.573-1.316-2.852-2.933-2.852s-2.933 1.28-2.933 2.852h.977c0-1.034.878-1.874 1.956-1.874s1.955.84 1.955 1.874-.877 1.874-1.955 1.874h-.913v.978h.913c1.078 0 1.955.84 1.955 1.874 0 1.033-.877 1.874-1.955 1.874s-1.956-.841-1.956-1.874h-.977c0 1.572 1.315 2.851 2.933 2.851s2.933-1.279 2.933-2.851c0-.982-.513-1.85-1.292-2.363a2.83 2.83 0 001.292-2.363zM13.554 10.31l.502.839 1.933-1.155v8.59h.978V8.27z"
        />
      </g>
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="google-gmail" xmlns="http://www.w3.org/2000/svg">
    <g stroke="null">
      <g fill="#F2F2F2">
        <path d="M22.49 5.898l-1.498 15.036H3.008L1.8 6.189 12 11.9z" />
        <path d="M21.982 3.066L12 12.442 2.018 3.066H12z" />
      </g>
      <path
        fill="#F14336"
        d="M3.008 7.396v13.538h-1.63c-.61 0-1.106-.495-1.106-1.106V5.402l1.787.048.949 1.946z"
      />
      <path
        fill="#D32E2A"
        d="M23.728 5.402v14.426c0 .61-.496 1.106-1.107 1.106h-1.629V7.396l.902-2.132 1.834.138z"
      />
      <path
        fill="#F14336"
        d="M23.728 4.172v1.23l-2.736 1.994L12 13.95 3.008 7.396.272 5.402v-1.23c0-.61.496-1.106 1.106-1.106h.64L12 10.341l9.982-7.275h.64c.61 0 1.106.495 1.106 1.106z"
      />
      <path fill="#D32E2A" d="M3.008 7.396L.272 6.972v-1.57z" />
    </g>
  </symbol>
  <symbol viewBox="0 0 533.5 544.3" id="google-logo-color" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z"
      fill="#4285f4"
    />
    <path
      d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z"
      fill="#34a853"
    />
    <path
      d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z"
      fill="#fbbc04"
    />
    <path
      d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z"
      fill="#ea4335"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="google-meet" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="evenodd">
      <path
        d="M7.586 6.79a1.302 1.302 0 00-.89.792l-.051.14-.008 2.704c-.008 3.222-.024 3.062.367 3.449.398.398.172.379 4.078.371l3.273-.008.168-.062c.391-.14.645-.399.786-.793.05-.149.054-.184.062-1.055l.008-.898 2.473 2.472.015-2.55c.008-1.403.016-2.942.016-3.418v-.868l-2.508 2.508v-.832c0-.496-.012-.89-.023-.972a1.301 1.301 0 00-.997-.997c-.23-.039-6.593-.027-6.77.016"
        fill="#ebebeb"
      />
      <path
        d="M11.805 1c.11.008.28.008.39 0 .106-.004.016-.008-.195-.008-.21 0-.3.004-.195.008m-.344.14c-4.582.262-8.492 3.965-8.895 8.426-.011.102-.023.18-.03.172-.009-.004-.016.059-.02.137 0 .078-.012.273-.02.426-.27 4.57 4.137 9.035 9.074 9.191l.43.016.004 1.75.008 1.754.351-.188c5.977-3.18 9.528-8.21 9.117-12.922a4.472 4.472 0 01-.023-.316.784.784 0 00-.023-.149.2.2 0 01-.004-.097c.004-.035.004-.055-.004-.047s-.035-.129-.067-.305C20.57 4.29 16.254.871 11.461 1.141m3 5.648c.43.125.77.469.879.887.027.113.035.304.035 1.008v.867l2.508-2.508v6.914l-2.504-2.504-.008.91c-.008.875-.012.918-.059 1.051a1.33 1.33 0 01-.769.774l-.14.05-3.34.008c-2.34.004-3.376-.004-3.465-.02-.422-.09-.778-.425-.938-.89-.058-.156-.07-5.32-.015-5.582.093-.461.453-.848.894-.969.188-.05 6.75-.05 6.922.004"
        fill="#0c8a7d"
      />
      <path
        d="M10.977 1.043a9.532 9.532 0 00-8.434 8.469c-.02.175-.035.363-.031.414 0 .05.015-.043.035-.211.687-6.438 7.277-10.34 13.203-7.817 2.95 1.258 5.063 3.95 5.625 7.172.04.211.063.325.059.246-.133-1.496-.918-3.37-1.957-4.687-1.559-1.973-3.692-3.188-6.27-3.566-.36-.051-1.828-.067-2.23-.02m10.468 8.539l.012.11.008-.09c.004-.051 0-.102-.012-.114-.012-.008-.015.032-.008.094m.032.285c0 .07.003.102.007.063a.336.336 0 000-.125c-.004-.04-.007-.008-.007.062m.023.422c0 .059.004.082.008.05a.24.24 0 000-.105c-.004-.027-.008-.004-.008.055"
        fill="#3fa59c"
      />
      <path
        d="M16.605 8.328l-1.242 1.246 1.246-1.242c.688-.684 1.25-1.246 1.25-1.246 0-.02-.097.082-1.254 1.242m-9.984.906c0 .704.004.989.004.641.004-.352.004-.93 0-1.277 0-.352-.004-.067-.004.636M17.863 12.2l-.004 1.711-1.25-1.242-1.246-1.242 1.246 1.254c.688.687 1.254 1.246 1.262 1.238.008-.008.008-.781.004-1.723l-.004-1.707-.008 1.711"
        fill="#8cc4bc"
      />
      <path
        d="M6.621 11.766c0 .703.004.988.004.636a69.62 69.62 0 000-1.277c0-.348-.004-.063-.004.64"
        fill="#5cb4a7"
      />
    </g>
  </symbol>
  <symbol
    style="width: 24px; height: 24px"
    viewBox="0 0 24 24"
    id="gplus"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 11h-2V9h-2v2h-2v2h2v2h2v-2h2M8 11v2.4h4c-.2 1-1.2 3-4 3-2.4 0-4.3-2-4.3-4.4 0-2.4 1.9-4.4 4.3-4.4 1.4 0 2.3.6 2.8 1.1l1.9-1.8C11.5 5.7 9.9 5 8 5c-3.9 0-7 3.1-7 7s3.1 7 7 7c4 0 6.7-2.8 6.7-6.8 0-.5 0-.8-.1-1.2H8z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="headset" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 1c-5 0-9 4-9 9v7a3 3 0 003 3h3v-8H5v-2a7 7 0 017-7 7 7 0 017 7v2h-4v8h4v1h-7v2h6a3 3 0 003-3V10c0-5-4.03-9-9-9z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="heart-off" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 4.27L2.28 3 20 20.72 18.73 22l-3.55-3.56-1.73 1.59L12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5c0-.95.23-1.83.63-2.6L1 4.27M7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.41 22 8.5c0 2.57-1.58 4.82-4.21 7.47L5.27 3.45C5.95 3.16 6.7 3 7.5 3z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="help" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="help-outline" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="help-plain" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 19h3v3h-3v-3m2-17c5.35.22 7.68 5.62 4.5 9.67-.83 1-2.17 1.66-2.83 2.5C13 15 13 16 13 17h-3c0-1.67 0-3.08.67-4.08.66-1 2-1.59 2.83-2.25C15.92 8.43 15.32 5.26 12 5a3 3 0 00-3 3H6a6 6 0 016-6z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="history" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="home" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="image" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="import-export" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="inbox" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="info" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="info-outline" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
    />
  </symbol>
  <symbol viewBox="0 0 2 9" id="information" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 2V0H0v2h2zM0 3v6h2V3H0z" fill-rule="evenodd" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="insert-emoticon" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="keyboard-arrow-down" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="keyboard-arrow-left" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="keyboard-arrow-right" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="keyboard-arrow-up" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="keyboard-backspace" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="keyboard-return" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="label" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="label-outline" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="link" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="link-off" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path
      d="M14.39 11L16 12.61V11zM17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4A4.986 4.986 0 0022 12c0-2.76-2.24-5-5-5zM2 4.27l3.11 3.11A4.991 4.991 0 002 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86 2 4.27z"
    />
  </symbol>
  <symbol
    style="width: 24px; height: 24px"
    viewBox="0 0 24 24"
    id="linkedin"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 21h-4v-6.75c0-1.06-1.19-1.94-2.25-1.94S13 13.19 13 14.25V21H9V9h4v2c.66-1.07 2.36-1.76 3.5-1.76 2.5 0 4.5 2.04 4.5 4.51V21M7 21H3V9h4v12M5 3a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 012-2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="list" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="local-activity" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="local-offer" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="location-city" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="lock" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    />
  </symbol>
  <symbol viewBox="0 0 361 66" id="logo__horizontal--grey" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M102.015 42.415a21.886 21.886 0 01-7.194 16.25.799.799 0 01-1.073-.02c-1.689-1.527-3.701-2.92-5.836-3.735-1.317-.502-3.455-.813-3.455-2.642 0-.378.11-.748.315-1.065a20.402 20.402 0 003.437-8.614v-.025c.12-.797.195-1.6.224-2.405v-.026a8.39 8.39 0 00-16.755 0v.026c.028.805.102 1.608.223 2.405v.024a20.404 20.404 0 003.356 8.499c.025.04.053.08.083.116.206.317.316.687.316 1.065 0 1.774-1.948 2.012-3.232 2.532a.754.754 0 00-.277 1.21 34.293 34.293 0 011.51 1.83 32.644 32.644 0 013.728 6.097l.025.045a.533.533 0 01.059.136.662.662 0 01.044.244.762.762 0 01-.758.758.74.74 0 01-.534-.225c-4.51-4.73-9.505-8.49-15.882-10.336a1.99 1.99 0 01-.437-.185c-.089-.053-.18-.104-.264-.161-1.484-.984-1.721-2.846-.925-4.352 1.157-2.179 2.545-4.126 3.49-6.433 2.411-5.883 3.921-13.184-.115-18.743a13.568 13.568 0 00-21.97 0c-4.036 5.559-2.526 12.86-.115 18.743.945 2.307 2.333 4.254 3.49 6.433.797 1.51.559 3.368-.925 4.352-.083.057-.175.108-.264.16-.138.08-.285.141-.437.186-6.377 1.845-11.371 5.606-15.884 10.336a.732.732 0 01-.68.211.76.76 0 01-.61-.744c0-.052.006-.104.018-.154a.356.356 0 01.026-.09.61.61 0 01.057-.136l.027-.045a32.644 32.644 0 013.728-6.098c.475-.63.983-1.24 1.51-1.83a.754.754 0 00-.277-1.209c-1.284-.52-3.231-.758-3.231-2.532 0-.378.109-.748.315-1.065a20.402 20.402 0 003.437-8.614v-.025c.121-.797.197-1.6.225-2.405v-.026a8.39 8.39 0 00-16.755 0v.026c.028.805.103 1.608.224 2.405v.024a20.404 20.404 0 003.356 8.499c.025.04.052.08.083.116.206.317.315.687.315 1.065 0 1.83-2.146 2.134-3.455 2.642-2.14.813-4.147 2.198-5.838 3.734a.799.799 0 01-1.073.02 21.953 21.953 0 0112.492-38.083.789.789 0 00.63-.458 33.336 33.336 0 0161.206 0 .789.789 0 00.63.464c11.178 1.167 19.67 10.59 19.672 21.828zm42.879-18.226c0 2.002-.335 3.8-1.016 5.337-1.297-.148-2.744-.26-3.633-.26-1.354 0-3.226.26-4.43.813-1.41.649-2.336 1.89-2.336 4.486v18.63c-1.724.835-3.726 1.168-6.007 1.168V31.874c0-3.58 1.39-5.433 4.56-6.708 2.483-1.002 5.654-1.52 8.13-1.52a21.42 21.42 0 014.732.543zm32.992 11.356c0-7.378-5.616-11.903-13.458-11.903-9.25 0-15.276 6.301-15.276 15.369 0 9.12 6.119 15.348 16.13 15.348a27.187 27.187 0 008.943-1.575c0-1.966-.297-3.726-1.016-5.228-2.02.667-4.931 1.336-7.694 1.336-5.598 0-9.399-2.745-10.269-7.694h16.058c4.618 0 6.582-1.297 6.582-5.653zm-22.591.907c.89-4.838 4.504-7.564 9.102-7.564 4.005 0 7.637 2.078 7.637 5.431 0 1.281-.537 2.133-2.502 2.133h-14.237zm26.849 2.558c0-9.047 6.155-15.368 16.13-15.368 2.977.021 5.93.535 8.74 1.52 0 1.966-.297 3.69-1 5.171a24.748 24.748 0 00-7.352-1.266c-6.47 0-10.493 3.93-10.493 9.936s4.041 9.805 10.383 9.805c2.706 0 5.635-.685 7.655-1.372.685 1.539 1.016 3.338 1.016 5.34a27.16 27.16 0 01-8.943 1.575c-9.98.008-16.136-6.295-16.136-15.34zm46.768-14.821c0 2.002-.334 3.8-1.017 5.337-1.296-.148-2.742-.26-3.632-.26-1.354 0-3.226.26-4.431.813-1.409.649-2.336 1.89-2.336 4.486v18.63c-1.723.835-3.725 1.168-6.006 1.168V31.874c0-3.58 1.39-5.433 4.561-6.708 2.484-1.002 5.653-1.52 8.13-1.52a21.42 21.42 0 014.73.543zm10.265 16.489c0 4.652 2.52 8.157 7.303 8.157.779 0 2.726-.092 4.32-.74 1.687-.687 2.28-1.763 2.28-3.374V24.81c1.724-.836 3.726-1.17 6.007-1.17v22.49c0 3.578-1.446 5.488-4.562 6.708-2.439.965-6.006 1.52-8.582 1.52-7.86 0-12.773-5.17-12.773-13.198V24.811c1.724-.836 3.726-1.17 6.007-1.17v17.037zm32.067-25.951a3.95 3.95 0 11-3.95-3.954 3.94 3.94 0 013.95 3.954zm-.966 38.463c-1.723.836-3.725 1.17-6.006 1.17V24.81c1.726-.835 3.728-1.168 6.006-1.168V53.19zm16.55-23.513v14.228c0 4.21 2.82 4.913 7.99 4.913 0 2.033-.296 3.801-1.038 5.322a9.42 9.42 0 01-2.187.221c-3.132 0-7.879-.742-9.806-4.95-.872-1.89-.965-4.064-.965-6.394v-13.34h-5.32c0-2.094.297-3.911 1.057-5.488h4.269V15.82c1.726-.835 3.728-1.169 6.006-1.169v9.554h8.176c0 2.075-.315 3.91-1.076 5.488l-7.106-.016zM328 35.545c0-7.378-5.618-11.903-13.46-11.903-9.251 0-15.276 6.301-15.276 15.369 0 9.12 6.118 15.348 16.13 15.348a27.177 27.177 0 008.943-1.575c0-1.966-.297-3.726-1.016-5.228-2.02.667-4.932 1.336-7.694 1.336-5.598 0-9.399-2.745-10.269-7.694h16.058c4.622 0 6.584-1.297 6.584-5.653zm-22.6.907c.891-4.838 4.505-7.564 9.103-7.564 4.004 0 7.637 2.078 7.637 5.431 0 1.281-.537 2.133-2.503 2.133h-14.236zm55.6-.907c0-7.378-5.616-11.903-13.458-11.903-9.25 0-15.276 6.301-15.276 15.369 0 9.12 6.119 15.348 16.13 15.348a27.187 27.187 0 008.943-1.575c0-1.966-.299-3.726-1.016-5.228-2.02.667-4.931 1.336-7.694 1.336-5.598 0-9.399-2.745-10.269-7.694h16.058c4.608 0 6.582-1.297 6.582-5.653zm-22.597.907c.888-4.838 4.504-7.564 9.102-7.564 4.005 0 7.637 2.078 7.637 5.431 0 1.281-.539 2.133-2.502 2.133h-14.237z"
      fill="#98B1BD"
    />
  </symbol>
  <symbol viewBox="0 0 270 173" id="logo__sign" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M269.87 112.636a57.944 57.944 0 01-19.049 43.035 2.111 2.111 0 01-2.84-.047c-4.48-4.073-9.808-7.744-15.487-9.891-3.49-1.327-9.174-2.148-9.174-6.98a5.163 5.163 0 01.837-2.829c.08-.096.155-.198.222-.304a54.026 54.026 0 008.884-22.504v-.067c.32-2.11.52-4.237.6-6.37v-.068c0-12.26-9.94-22.199-22.2-22.199s-22.198 9.94-22.198 22.2v.066c.095 2.138.312 4.268.65 6.381v.067A54.026 54.026 0 00199 135.63c.063.109.138.21.222.304.543.844.831 1.826.831 2.83 0 4.697-5.163 5.327-8.56 6.71a1.998 1.998 0 00-.733 3.202 84.796 84.796 0 014.001 4.868 86.498 86.498 0 019.871 16.153l.072.12c.065.113.116.234.15.36a.8.8 0 01.067.238c.035.133.052.27.052.408a2.019 2.019 0 01-1.616 1.972c-.13.022-.26.034-.392.036a1.957 1.957 0 01-1.41-.594c-11.951-12.53-25.177-22.488-42.07-27.361a5.601 5.601 0 01-1.156-.49c-.237-.14-.475-.274-.696-.429-3.934-2.581-4.564-7.522-2.453-11.523 3.067-5.771 6.743-10.929 9.246-17.036 6.381-15.575 10.382-34.914-.31-49.643a35.936 35.936 0 00-58.186 0c-10.687 14.729-6.711 34.073-.305 49.643 2.504 6.112 6.195 11.27 9.246 17.036 2.112 4.001 1.482 8.921-2.452 11.523-.222.155-.46.29-.697.428a5.529 5.529 0 01-1.161.49c-16.887 4.89-30.113 14.848-42.065 27.362-.37.381-.878.595-1.409.594a2.462 2.462 0 01-.392-.036 2.024 2.024 0 01-1.621-1.972c.002-.138.019-.274.051-.408a.986.986 0 01.073-.238c.034-.126.084-.247.15-.36a.883.883 0 00.066-.12 86.524 86.524 0 019.876-16.153 75.199 75.199 0 014.001-4.868 1.998 1.998 0 00-.733-3.201c-3.402-1.379-8.565-2.008-8.565-6.712a5.224 5.224 0 01.837-2.829 2.22 2.22 0 00.222-.304 54.026 54.026 0 008.885-22.504v-.067c.32-2.11.52-4.237.598-6.37v-.067c-.571-11.845-10.34-21.154-22.198-21.154-11.859 0-21.628 9.31-22.2 21.154v.067c.096 2.134.314 4.26.651 6.37v.067a54.026 54.026 0 008.9 22.494c.066.107.14.209.222.304a5.23 5.23 0 01.837 2.83c0 4.831-5.68 5.678-9.18 6.979-5.678 2.163-10.975 5.818-15.456 9.891a2.111 2.111 0 01-2.84.047 58.135 58.135 0 0133.04-100.86 2.065 2.065 0 001.668-1.23C67.941 21.236 99.8.287 135.031.287c35.232 0 67.09 20.949 81.052 53.296.302.673.934 1.14 1.667 1.229 29.618 3.085 52.117 28.047 52.12 57.825z"
      fill="#fff"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="loop" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0020 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 004 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="mail" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="mail-outline" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="markunread" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="markunread-mailbox" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
    />
  </symbol>
  <symbol viewBox="0 0 29 19" id="mastercard" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path
        d="M27 0H2C.816 0 0 .814 0 2v15c0 1.186.816 2 2 2h25c1.184 0 2-.814 2-2V2c0-1.186-.816-2-2-2z"
        fill="#000001"
      />
      <circle fill="#F40727" cx="10.909" cy="10" r="6.364" />
      <circle fill="#FD9D35" cx="18.182" cy="10" r="6.364" />
      <path
        d="M14.545 15.223A6.356 6.356 0 0111.818 10a6.356 6.356 0 012.727-5.223A6.356 6.356 0 0117.273 10a6.356 6.356 0 01-2.728 5.223z"
        fill="#FD5F23"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="meeting-room" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6h-3zm-4 5v2h2v-2h-2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="mention" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.45 11.91c-.11-2.21-1.75-3.54-3.73-3.54h-.08c-2.29 0-3.55 1.8-3.55 3.84 0 2.29 1.53 3.74 3.54 3.74 2.25 0 3.72-1.65 3.83-3.59m-3.81-5.97c1.53 0 2.97.68 4.02 1.74 0-.51.33-.89.83-.89h.11c.74 0 .89.7.89.92v7.9c-.04.52.54.78.87.44 1.27-1.29 2.78-6.69-.79-9.81-3.33-2.92-7.8-2.44-10.18-.8-2.52 1.74-4.14 5.61-2.57 9.22 1.71 3.95 6.61 5.13 9.52 3.95 1.48-.59 2.15 1.4.65 2.05-2.34.99-8.77.89-11.78-4.32-2.03-3.52-1.93-9.71 3.46-12.92C10.81 1.42 16.24 2.1 19.5 5.5c3.45 3.6 3.25 10.3-.1 12.91-1.51 1.18-3.76.03-3.74-1.7l-.02-.56a5.611 5.611 0 01-3.99 1.66C8.63 17.81 6 15.15 6 12.13c0-3.05 2.63-5.74 5.65-5.74z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="menu" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="merge-type" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="message" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
    />
  </symbol>
  <symbol viewBox="0 0 15.83 15.83" id="microsoft-logo" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.668 1.086H1.086v7.582h7.582V1.086z" fill="#F25022" />
    <path d="M16.913 1.086H9.332v7.582h7.581V1.086z" fill="#7FBA00" />
    <path d="M8.668 9.332H1.086v7.581h7.582V9.332z" fill="#00A4EF" />
    <path d="M16.913 9.332H9.332v7.581h7.581V9.332z" fill="#FFB900" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="microsoft-outlook" xmlns="http://www.w3.org/2000/svg">
    <g fill="#006ebc" stroke="null">
      <path
        d="M23.832 8.923c0-.434-.31-.786-.69-.786h-6.788v1.57h5.371l-3.523 2.904-1.848-1.515v1.993l1.45 1.175c.235.19.566.19.801-.002l3.845-3.117v4.152h-6.096v1.57h6.787c.38 0 .69-.35.69-.786V9.62c0-.018 0-.036-.002-.055a.737.737 0 00.003-.054v-.587zM7.56 15.243c.99 0 1.627-1.306 1.627-3.255 0-1.617-.47-3.256-1.628-3.256-1.223 0-1.676 1.66-1.676 3.256 0 1.86.587 3.255 1.676 3.255z"
      />
      <path
        d="M.168 21.831L14.9 22.912V1.088L.168 2.384v19.447zm7.46-15.49c2.515 0 4.193 2.28 4.193 5.535 0 3.964-2.132 5.78-4.328 5.78-2.399 0-4.244-2.08-4.244-5.579.001-3.501 1.746-5.736 4.378-5.736z"
      />
    </g>
  </symbol>
  <symbol
    stroke-miterlimit="1.414"
    stroke-linejoin="round"
    fill-rule="evenodd"
    clip-rule="evenodd"
    viewBox="0 0 220 220"
    id="microsoft-teams"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle r="32.086" fill="#7b83eb" cy="41.25" cx="116.875" />
    <path
      fill-rule="nonzero"
      fill-opacity=".098"
      d="M114.586 48.125H85.532l.144.639.014.055.144.592c4.362 16.534 21.203 26.834 37.909 23.182V57.289c-.015-5.021-4.142-9.149-9.164-9.164z"
    />
    <path
      fill-rule="nonzero"
      fill-opacity=".2"
      d="M107.711 55H87.883c5.302 11.18 16.618 18.336 28.992 18.336v-9.165c-.015-5.022-4.143-9.149-9.164-9.164z"
    />
    <circle r="24.063" fill="#5059c9" cy="51.563" cx="189.063" />
    <g fill-rule="nonzero">
      <path
        fill="#5059c9"
        d="M209.688 82.5h-54.045c-2.41 0-4.393 1.983-4.393 4.393v55.756c-.31 16.57 11.12 31.225 27.266 34.96 2.325.488 4.693.733 7.068.733 18.872 0 34.404-15.521 34.416-34.393V92.812c0-5.657-4.655-10.312-10.312-10.312z"
      />
      <path
        fill="#7b83eb"
        d="M171.875 92.813v65.343c0 30.153-24.812 54.965-54.966 54.965-19.618 0-37.804-10.503-47.609-27.496a49.447 49.447 0 01-3.438-6.875 57.483 57.483 0 01-2.268-6.875 56.622 56.622 0 01-1.719-13.75V92.812v-.013c0-5.65 4.649-10.299 10.299-10.299h89.402c5.65 0 10.299 4.649 10.299 10.299z"
      />
      <path
        fill-opacity=".2"
        d="M107.711 55H87.883c5.302 11.18 16.618 18.336 28.992 18.336v-9.165c-.015-5.022-4.143-9.149-9.164-9.164z"
      />
      <path
        fill-opacity=".098"
        d="M123.75 82.5v87.106a9.101 9.101 0 01-7.15 8.869 6.66 6.66 0 01-1.994.275H65.862a57.483 57.483 0 01-2.268-6.875 56.622 56.622 0 01-1.719-13.75V92.812v-.013c0-5.65 4.649-10.299 10.299-10.299z"
      />
      <path
        fill-opacity=".2"
        d="M116.875 82.5v93.981a6.66 6.66 0 01-.275 1.994 9.101 9.101 0 01-8.869 7.15H69.3a49.33 49.33 0 01-3.437-6.875 57.31 57.31 0 01-2.269-6.875 56.622 56.622 0 01-1.719-13.75V92.812v-.013c0-5.65 4.649-10.299 10.299-10.299zm0 0v80.231c-.023 5.008-4.136 9.121-9.144 9.144H63.594a56.622 56.622 0 01-1.719-13.75V92.812v-.013c0-5.65 4.649-10.299 10.299-10.299zm-44.688 0h-.013c-5.65 0-10.299 4.649-10.299 10.299v65.326a56.622 56.622 0 001.719 13.75h37.262c5.008-.023 9.121-4.136 9.144-9.144V82.5z"
      />
      <path
        fill="#4b53bc"
        d="M9.164 55h91.665c5.027 0 9.164 4.137 9.164 9.164v91.665c0 5.027-4.137 9.164-9.164 9.164H9.164c-5.027 0-9.164-4.137-9.164-9.164V64.164C0 59.137 4.137 55 9.164 55z"
      />
      <path fill="#fff" d="M82.363 89.203h-20.55v55.138H48.311V89.203H27.644V75.659h54.719z" />
    </g>
    <path fill="none" d="M0 0h220v220H0z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="more-horiz" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="more-vert" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="my-location" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="navbar-activities" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.9 8.072l2.388 7.165c.238.712 1.258.673 1.44-.055l2.295-9.183 1.252 4.694a.75.75 0 00.725.557h3v-1.5h-2.424l-1.851-6.943c-.2-.749-1.265-.74-1.453.011L8.897 12.32 6.712 5.763c-.217-.65-1.12-.693-1.397-.068L3.513 9.75H1v1.5h3a.75.75 0 00.685-.445L5.9 8.072z"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="navbar-referrals">
    <path
      d="M15.66 10.102a3 3 0 11-3.457 4.841A6.72 6.72 0 019 15.75a6.72 6.72 0 01-3.203-.807 3 3 0 11-3.458-4.842 6.75 6.75 0 013.785-7.21 3.001 3.001 0 015.751 0 6.75 6.75 0 013.786 7.21zm-1.463-.352a5.245 5.245 0 00-2.321-5.143 3.001 3.001 0 01-5.752 0 5.245 5.245 0 00-2.32 5.143 3 3 0 012.801 3.923A5.228 5.228 0 009 14.25c.863 0 1.677-.208 2.395-.577a3 3 0 012.802-3.923zM9 5.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-5.25 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm10.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="next-week" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="notifications-active" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2a8.445 8.445 0 013.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43a8.495 8.495 0 013.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="notifications-none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
    />
  </symbol>
  <symbol style="width: 24px; height: 24px" viewBox="0 0 24 24" id="numeric">
    <path
      d="M4 17V9H2V7h4v10H4m18-2a2 2 0 01-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4a2 2 0 012 2v1.5a1.5 1.5 0 01-1.5 1.5 1.5 1.5 0 011.5 1.5V15m-8 0v2H8v-4a2 2 0 012-2h2V9H8V7h4a2 2 0 012 2v2a2 2 0 01-2 2h-2v2h4z"
    />
  </symbol>
  <symbol viewBox="0 0 53.59 64.356" id="office-logo" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M.496 51.609V13.092L34.568.501l18.517 5.925v51.849l-18.517 5.582L.496 51.609l34.072 4.1V10.871l-22.221 5.185v30.369z"
      fill="#eb3c00"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="open-in-new" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="pause" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="people" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="people-outline" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="person" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="person-add" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="person-outline" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 5.9a2.1 2.1 0 110 4.2 2.1 2.1 0 010-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="person-pin" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 2H5a2 2 0 00-2 2v14a2 2 0 002 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="phone" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="pin" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="pipeline" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 2v14h-4V2h4m-7 0v20h-4V2h4M7 2v8H3V2h4z" />
  </symbol>
  <symbol viewBox="0 0 16 16" id="pipeline-created-at" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 2C4.682 2 2 4.688 2 8s2.682 6 6 6c3.312 0 6-2.688 6-6s-2.688-6-6-6zm0 11c-2.763 0-5-2.238-5-5 0-2.763 2.237-5 5-5 2.762 0 5 2.237 5 5 0 2.762-2.238 5-5 5zm0-8H7v3.5l4 1.5V9L8 8V5z"
      fill="#4D6072"
      fill-rule="nonzero"
    />
  </symbol>
  <symbol viewBox="0 0 16 16" id="pipeline-event" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 3.076V2h-2v1.076H6V2H4v1.076c-1.385 0-2 .382-2 1.299v8.25C2 13.542 2.462 14 3.385 14h8.769C13.538 14 14 13.542 14 12.625v-8.25c0-.917-.615-1.299-2-1.299zM13 13H3V5h10v8zM4 6h3v3H4V6z"
    />
  </symbol>
  <symbol viewBox="0 0 16 16" id="pipeline-notes" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 2a1 1 0 011 1v7a1 1 0 01-1 1H6l-4 3V3a1 1 0 011-1zM9 7H5v1h4V7zm2-2H5v1h6V5z"
      fill="#4D6072"
      fill-rule="nonzero"
    />
  </symbol>
  <symbol
    viewBox="0 0 16 16"
    id="pipeline-pending-result-request"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 2h8v4L9.5 8l2.5 2v4H4v-4l2.5-2L4 6V2m7 9L8 8l-3 3v2h6v-2zm0-6V3H5v2l3 3 3-3zM6 4h4L8 6 6 4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="place" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="play-arrow" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 5v14l11-7z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="playlist-add" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="playlist-add-check" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="poll-plain" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 22V8h4v14H3m7 0V2h4v20h-4m7 0v-8h4v8h-4z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="power-settings-new" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42A6.92 6.92 0 0119 12c0 3.87-3.13 7-7 7A6.995 6.995 0 017.58 6.58L6.17 5.17A8.932 8.932 0 003 12a9 9 0 0018 0c0-2.74-1.23-5.18-3.17-6.83z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="print" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="public" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="pulse" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 13h2.79l4.31-8.21 1.18 8.96 3.22-4.09L17.83 13H21v2h-4l-2.33-2.33-4.75 6.06-.98-7.42L7 15H3v-2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="question-answer" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="radio-button-checked" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="radio-button-unchecked" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="rating-double-thumb-down" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.601 18.015l.67-3.315H5.75c-.963 0-1.75-.81-1.75-1.8l.009-.072L4 12.819V11.1c0-.234.044-.45.122-.657L5.556 7H3.75a1.49 1.49 0 00-1.38.915L.105 13.202A1.482 1.482 0 000 13.75v1.433l.007.007-.007.06c0 .825.675 1.5 1.5 1.5h4.732l-.712 3.428-.023.24c0 .307.128.592.33.795l.795.787 3.98-3.985zM24 3h-3v9h3V3zM7 11.25c0 .825.675 1.5 1.5 1.5h4.732l-.712 3.428-.022.24c0 .307.127.592.33.795l.794.787 4.935-4.942c.278-.27.443-.645.443-1.058V4.5c0-.825-.675-1.5-1.5-1.5h-6.75a1.49 1.49 0 00-1.38.915L7.105 9.203A1.482 1.482 0 007 9.75v1.433l.007.007-.007.06z"
    />
  </symbol>
  <symbol viewBox="0 0 16 16" id="rating-double-thumb-up" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.667 3l-.307.287c-.24.22-.433.47-.587.746a.567.567 0 00-.053.403L8.5 7H5C4 7 4 8 4 8.5 4 10 5 12 5.5 13s1.033 1 1.5 1h4.5c.86 0 1.5-.718 1.5-1.5v-4c0-1-.5-1.375-.5-1.375L8.667 3zM15 7a1 1 0 00-1 1v5a1 1 0 001 1h1V7h-1z"
    />
    <path
      d="M6.584 4.39L7 6.38H3.571c-.598 0-1.087.486-1.087 1.08l.006.043-.006.006V8.54c0 .14.027.27.076.394L3.45 11H2.33a.926.926 0 01-.857-.549L.065 7.278A.863.863 0 010 6.95v-.86l.005-.004L0 6.05c0-.495.42-.9.932-.9H3.87l-.443-2.057-.014-.143c0-.185.08-.356.205-.478L4.113 2l2.47 2.39z"
    />
  </symbol>
  <symbol viewBox="0 0 16 16" id="rating-thumb-down" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.667 14l-.307-.287c-.24-.22-.433-.47-.587-.746a.567.567 0 01-.053-.403L6.5 10H3c-1 0-1-1-1-1.5C2 7 3 5 3.5 4c.441-.882.908-.986 1.333-.998L9.5 3c.86 0 1.5.718 1.5 1.5v4c0 1-.5 1.375-.5 1.375L6.667 14zM13 10a1 1 0 01-1-1V4a1 1 0 011-1h1v7h-1z"
    />
  </symbol>
  <symbol viewBox="0 0 16 16" id="rating-thumb-up" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.667 2l-.307.287c-.24.22-.433.47-.587.746a.567.567 0 00-.053.403L6.5 6H3C2 6 2 7 2 7.5 2 9 3 11 3.5 12s1.033 1 1.5 1h4.5c.86 0 1.5-.718 1.5-1.5v-4c0-1-.5-1.375-.5-1.375L6.667 2zM13 6a1 1 0 00-1 1v5a1 1 0 001 1h1V6h-1z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="rating-thumbs-up-down" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="recruitee-logo" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.33 10.274h-.044a7.772 7.772 0 00-14.73.002 4.532 4.532 0 00-3.06 7.762c.092.091.237.1.339.02.111-.086.233-.176.366-.265.43-.32 1.02-.602 1.56-.798.072-.025.418-.214.225-.722a3.212 3.212 0 01-.873-2.14c0-1.24.82-1.89 1.78-1.89.958 0 1.782.65 1.782 1.89 0 .806-.377 1.625-.873 2.134h.003c-.188.576.116.714.163.728.167.056.337.12.506.189a.13.13 0 01.04.212c-.454.438-.719.997-.858 1.387-.046.128.112.23.21.137.336-.314.783-.69 1.345-1.069.74-.55 1.754-1.034 2.682-1.37.125-.044.72-.369.389-1.243-.855-.875-1.501-2.29-1.501-3.682 0-2.133 1.409-3.251 3.06-3.251 1.648 0 3.066 1.118 3.066 3.25 0 1.388-.649 2.797-1.501 3.672h.005c-.325.992.198 1.228.279 1.253.946.314 1.954.773 2.701 1.304.625.384 1.13.777 1.518 1.12.1.089.252-.014.207-.14-.138-.389-.41-.961-.877-1.403a.13.13 0 01.039-.213c.143-.062.287-.119.428-.17.072-.025.42-.214.226-.724-.498-.51-.875-1.336-.875-2.148 0-1.244.822-1.896 1.785-1.896.961 0 1.788.652 1.788 1.896 0 .81-.378 1.631-.875 2.142h.003c-.19.578.115.716.162.73.792.263 1.658.7 2.042 1.185a.258.258 0 00.374.033 4.532 4.532 0 00-3.006-7.922"
      stroke="null"
      fill="#1999E3"
      fill-rule="evenodd"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="refresh" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="remove" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 13H5v-2h14v2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="remove-circle" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="remove-red-eye" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="reorder" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="replay" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="reply" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="reply-all" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" />
  </symbol>
  <symbol viewBox="0 0 16 16" id="report-breakdown" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.387 11.058l-5.13-8.862a2.648 2.648 0 00-3.626-.97 2.559 2.559 0 00-.978.97l-5.12 8.862a2.625 2.625 0 00.97 3.609c.4.249.853.373 1.324.373h10.266a2.66 2.66 0 002.65-2.667c0-.462-.125-.915-.356-1.315m-13.28.88l5.102-8.854c.24-.417.791-.577 1.2-.328a.803.803 0 01.338.328l5.102 8.854a.89.89 0 01-.329 1.209.851.851 0 01-.436.124H2.854a.891.891 0 01-.88-.898c0-.15.035-.302.115-.435h.018M7.973 8.4a1.753 1.753 0 01-1.75-1.769c0-.987.773-1.778 1.75-1.778.982 0 1.778.796 1.778 1.778 0 .978-.8 1.769-1.795 1.769h.017m-2.23 3.982a1.768 1.768 0 110-3.538c.977 0 1.777.792 1.777 1.77 0 .977-.8 1.768-1.778 1.768m4.427 0A1.778 1.778 0 018.4 10.613a1.778 1.778 0 011.769-1.769c.978 0 1.778.792 1.778 1.77 0 .977-.8 1.768-1.778 1.768z"
      fill-rule="evenodd"
    />
  </symbol>
  <symbol viewBox="0 0 16 16" id="report-funnel" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.993 10.997H7.86L6.738 9.021h2.377l-1.122 1.976zM9.675 8.034H6.177L5.056 6.058h5.74l-1.12 1.976zM11.357 5.07H4.495l-1.12-1.976h9.103L11.357 5.07z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.637 12.688L.365 3.934A2.522 2.522 0 010 2.634C-.01 1.185 1.215.01 2.722 0h10.552c.484 0 .95.123 1.361.369 1.306.711 1.754 2.31.996 3.565l-2.45 4.074v.026h-.014l-2.798 4.654a2.583 2.583 0 01-1.005.957c-1.306.729-2.978.299-3.727-.957zm3.133-.878l5.244-8.746h.018a.807.807 0 00.119-.43c.009-.483-.402-.878-.905-.887H2.732a.902.902 0 00-.448.123c-.439.255-.585.773-.338 1.194L7.19 11.81c.082.14.2.255.347.325.42.246.986.088 1.233-.325z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="report-problem" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
  </symbol>
  <symbol viewBox="0 0 16 16" id="report-single_metric" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0a8 8 0 108 8c0-.928-.168-1.848-.488-2.712l-1.28 1.28c.112.472.168.952.168 1.432A6.4 6.4 0 118 1.6c.48 0 .96.056 1.432.168L10.72.48A8.082 8.082 0 008 0m5.6 0l-3.2 3.2v1.2L8.36 6.44C8.24 6.4 8.12 6.4 8 6.4A1.6 1.6 0 109.6 8c0-.12 0-.24-.04-.36L11.6 5.6h1.2L16 2.4h-2.4V0M8 3.2A4.8 4.8 0 1012.8 8h-1.6A3.2 3.2 0 118 4.8V3.2z"
      fill-rule="evenodd"
    />
  </symbol>
  <symbol viewBox="0 0 16 10" id="report-trend" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.2 0l1.832 1.832-3.904 3.904-3.2-3.2L0 8.472 1.128 9.6l4.8-4.8 3.2 3.2 5.04-5.032L16 4.8V0z"
      fill-rule="evenodd"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="required" xmlns="http://www.w3.org/2000/svg">
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M14.164 10.262v-5.25h-3.36v5.25L6.058 8.414l-1.134 3.234 4.872 1.638-3.108 4.116 2.814 2.058 2.94-4.326 3.108 4.326 2.772-2.058-3.108-4.116 4.956-1.638-1.134-3.234z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="resize-bottom-right" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 22h-2v-2h2v2m0-4h-2v-2h2v2m-4 4h-2v-2h2v2m0-4h-2v-2h2v2m-4 4h-2v-2h2v2m8-8h-2v-2h2v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="restore" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="reward" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 2v9c0 1 1 2 2 2h2.2c.4 2 1.7 3.7 4.8 4v2.1c-2.2.2-3 1.3-3 2.6v.3h8v-.3c0-1.3-.8-2.4-3-2.6V17c3.1-.3 4.4-2 4.8-4H20c1 0 2-1 2-2V2h-4c-.9 0-2 1-2 2H8c0-1-1.1-2-2-2H2m2 2h2v7H4V4m14 0h2v7h-2V4M8 6h8v5.5c0 1.93-.58 3.5-4 3.5-3.41 0-4-1.57-4-3.5V6z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="room" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="routes" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 10H5L3 8l2-2h6V3l1-1 1 1v1h6l2 2-2 2h-6v2h6l2 2-2 2h-6v6a2 2 0 012 2H9a2 2 0 012-2V10z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="rss-feed" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6.18" cy="17.82" r="2.18" />
    <path
      d="M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-appical" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.82 1l6.816 3.999.003-.001v10.168l-1.845-1.085L8.82 17 2 12.998V4.998h.001L8.82 1zm0 2.245L3.913 6.123h-.001v5.754l4.906 2.877 4.907-2.877V6.122h-.001L8.819 3.246z"
      fill="#8AA2AD"
      fill-rule="nonzero"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-bamboo-hr" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#8AA2AD"
      fill-rule="evenodd"
      d="M12.927 14.818c2.128 0 3.491-1.527 3.491-3.49 0-1.8-1.254-3.546-3.436-3.546-2.127 0-3.491 1.636-3.491 3.6a3.422 3.422 0 003.436 3.436zm.164-8.454c2.564 0 4.854 2.236 4.8 4.854 0 2.782-2.127 4.964-4.964 4.964-2.563 0-4.8-1.855-4.8-4.746V2H9.6v5.782l.164-.164c.654-.654 1.581-1.254 3.327-1.254zM7.418 8.273s-.654-.11-1.2-.218c-.6-.11-.873-.164-1.69-.491C3.763 7.236 3 6.473 2.344 5.6 1.636 4.727 0 3.364 0 3.364s.49.054 1.036.163c.437.11 1.528.437 2.619 1.037.272.109.381.218.654.381.382.219.764.6 1.146.982.436.437.818.818 1.145 1.2-.382-.654-1.31-3.054-3.11-5.018-.163-.218 1.255.71 1.637 1.091 1.091 1.2 1.255 1.855 1.637 2.945l.654 2.128z"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-bryq" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.27 7.23v.74l.03-.058a1.244 1.244 0 01.886-.664c.074-.013.082-.016.374-.017h.967l.49 1.464.49 1.464.47-1.464.47-1.466h.955c.188 0 .315.001.315.002l-.112.3c-.06.163-.397 1.057-.746 1.988-.816 2.174-.818 2.18-.848 2.255-.185.454-.374.725-.62.886-.16.106-.35.164-.59.183a4.826 4.826 0 01-.333 0 1.988 1.988 0 01-.899-.288c-.007-.005 0-.021.1-.235a146.174 146.174 0 00.301-.649.372.372 0 01.068.031c.08.04.133.063.202.086a.767.767 0 00.27.045c.101 0 .177-.019.236-.058a.516.516 0 00.158-.192l.015-.03-.244-.665-.559-1.521-.345-.94-.03-.084h-.275c-.11 0-.152.005-.228.018-.414.071-.73.34-.877.749a1.596 1.596 0 00-.086.399l-.005 1.017-.002 1.012-1.237.002V7.23h1.24zm7.09-.079a1.897 1.897 0 01.854.168c.152.075.266.157.389.28.062.062.09.094.146.166l.01.014.001-.275v-.275H17v5.555h-1.24l-.002-1.816-.036.05c-.226.303-.54.499-.921.574-.28.055-.598.044-.877-.032-.68-.185-1.187-.731-1.376-1.486a2.802 2.802 0 01-.08-.685 3.744 3.744 0 01.01-.274c.016-.21.073-.467.15-.674.236-.634.713-1.078 1.325-1.232a1.889 1.889 0 01.407-.058zM3.247 6.002c.489.002.532.005.636.016.321.032.593.106.822.222.108.054.186.103.274.173.051.04.151.14.192.192.182.23.272.506.273.837 0 .135-.017.256-.055.387a1.464 1.464 0 01-.203.418 1.302 1.302 0 01-.467.406 2.355 2.355 0 01.306.152c.377.23.585.547.64.976.016.13.016.325 0 .456a1.502 1.502 0 01-.102.385c-.164.385-.5.654-.994.797-.149.043-.339.08-.488.095l-.04.004-.026.003c-.17.018-.252.018-1.662.019H1V6.002zM14.706 8.23l-.045.001a1 1 0 00-.771.475 1.38 1.38 0 00-.107.22 1.398 1.398 0 00.012.953c.117.294.345.515.628.61.253.083.543.065.775-.051.37-.185.587-.575.586-1.048 0-.347-.118-.65-.336-.87a.99.99 0 00-.552-.282 1.825 1.825 0 00-.235-.007zM3.226 9.257h-.978v1.18l.74-.002.703-.002.05-.001a.346.346 0 01.034-.005c.229-.022.424-.105.527-.226a.534.534 0 00.12-.38c-.016-.321-.262-.519-.693-.558a10.225 10.225 0 00-.502-.006zm-.089-2.152h-.89v1.112H3.45c.042 0 .05-.001.063-.002.266-.023.43-.084.543-.205a.45.45 0 00.116-.238.683.683 0 00-.012-.279.478.478 0 00-.252-.293.915.915 0 00-.329-.089 6.883 6.883 0 00-.442-.006z"
      fill="#8AA2AD"
      fill-rule="nonzero"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-checkr" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h18v18H0z" />
      <path
        d="M17 9.275v5.576h-1.638V9.477c0-.926-.398-1.358-1.25-1.358-.494 0-.908.214-1.268.65a2.02 2.02 0 00-.203.296 2.568 2.568 0 00-.278.78 3.925 3.925 0 00-.069.757v4.247h-1.648V12.61c-.051.06-.099.116-.15.172-1.017 1.154-2.205 1.877-3.506 2.133-.042.008-.083.016-.123.022-.224.035-.45.056-.676.063h-.346c-1.279 0-2.695-.466-3.52-1.612C1.58 12.345 1 10.752 1 9c0-1.752.553-3.364 1.326-4.389C3.169 3.495 4.526 3 5.803 3c1.032 0 2.306.352 2.976 1.043.185.19.354.399.502.622L8.18 6.092c-.71-1.177-1.41-1.35-2.377-1.346-.639 0-1.597.316-2.175 1.167-.518.76-.83 1.904-.83 3.09 0 1.179.318 2.265.82 3.03.163.236.877 1.119 2.355 1.119.28-.002.558-.03.832-.087 1.945-.473 3.131-2.387 3.692-3.572.055-.116.106-.226.149-.326V3.15h1.65v4.091c.204-.168.425-.31.66-.425.444-.228.931-.347 1.426-.35.843 0 1.496.234 1.938.694.45.47.682 1.186.68 2.114z"
        fill="#8AA2AD"
        fill-rule="nonzero"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 50 50" id="rti-codility" xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor">
      <path
        d="M42.636 29.896c-7.153 0-6.954-.008-7.278.364-.166.198-1.813 4.65-1.813 4.911 0 .293.221.704.458.87.198.135.618.142 6.83.182l6.6.04a32.955 32.955 0 001.921-6.322v-.045z"
        fill-rule="evenodd"
      />
      <path
        d="M17.591 7.102a9.783 9.783 0 00-1.086.038c-2.334.222-4.155.72-5.967 1.62-4.613 2.31-7.92 6.85-8.79 12.086-.183 1.052-.238 3.25-.127 4.357.601 5.695 4.011 10.677 8.988 13.12 5.016 2.468 10.809 2.112 15.525-.94.807-.523 1.021-.807.942-1.234-.063-.3-2.58-3.528-2.984-3.82-.42-.293-.664-.238-1.424.324-1.147.838-2.279 1.352-3.553 1.59-.838.158-2.334.158-3.165 0-3.53-.665-6.448-3.639-7.437-7.585-1.005-3.962.086-8.2 2.8-10.921 2.334-2.325 5.46-3.22 8.443-2.397.784.213 2.026.822 2.802 1.368.704.498.988.554 1.352.27.404-.325 3.118-3.797 3.166-4.066.079-.427-.143-.704-.998-1.265-2.104-1.377-4.636-2.246-7.24-2.484a17.185 17.185 0 00-1.247-.061z"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-codility-code-live" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.149 6.723l3.088 1.893-3.088 1.892V6.723zM6.895 12.12L5.78 13.191 1 8.596 5.78 4l1.115 1.072L3.23 8.596l3.665 3.523zm4.21 0l3.665-3.523-3.665-3.524L12.22 4 17 8.596l-4.78 4.595-1.115-1.072z"
      fill="#8AA2AD"
      fill-rule="evenodd"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-docu-sign" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero" fill="none">
      <path fill="#D6FB00" d="M1 1h16v16H1z" />
      <path d="M3.133 13.267h11.734v1.6H3.133v-1.6zM8.2 3.133h1.6V11.4H8.2V3.133z" fill="#000" />
      <path
        fill="#000"
        d="M11.234 7.768l1.132 1.131-3.5 3.499-3.498-3.499 1.131-1.131 2.368 2.367z"
      />
    </g>
  </symbol>
  <symbol viewBox="1 3 39 40" id="rti-enboarder" xmlns="http://www.w3.org/2000/svg">
    <g fill="#8AA2AD" fill-rule="evenodd">
      <path
        d="M8.163 32.567c-1.79.44-2.898 2.331-2.48 4.225.415 1.885 2.206 3.061 3.99 2.621 1.79-.442 2.902-2.334 2.484-4.226-.418-1.888-2.204-3.062-3.994-2.62M30.298 27.597c-.067-.004-.1-.013-.207-.007-.532.035-.485-.719-.485-.719l-.007.003c.564-1.298.883-2.73.883-4.242 0-.14-.007-.277-.01-.415-.08-.465-.532-.722-.723-.912-.518-.534-1.116-1.374-1.369-2.352-.27-1.05.018-1.598.034-2.16.006-.3.02-.373-.489-1.086-1.9-2.223-4.706-3.63-7.83-3.63-1.192 0-2.327.216-3.392.59-.043.016-.059.003-.118.03-1.346.62-1.876-.964-1.876-.964l-.005.003a7.79 7.79 0 00-1.657-2.86A7.5 7.5 0 002.325 8.5C-.742 11.403-.738 16.15 2.12 19.26c1.569 1.713 4.33 2.311 6.033 2.311h.073c.387 0 1.44.15 1.532 1.67.003.026.006.126.008.15.416 5.44 4.876 9.763 10.34 9.763 2.892 0 5.503-1.193 7.383-3.128.147-.039.51-.09.667.293a.99.99 0 00.16.263 1.959 1.959 0 003.068.502c.814-.75.876-2.024.134-2.853a1.938 1.938 0 00-1.219-.634M37.901 14.813a3.723 3.723 0 00-5.195-.94 3.778 3.778 0 00-.932 5.232 3.72 3.72 0 005.199.939 3.775 3.775 0 00.928-5.23"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-harver" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#8AA2AD"
      d="M10.221 7.145c-1.013.027-2.019.17-2.998.427 0 0 .24-4.736-2.223-5.572.616 1.617.509 4.98.509 5.162v8.59a.248.248 0 00.265.247h1.385a.235.235 0 00.249-.247V8.827a11.498 11.498 0 012.514-.335c.998 0 1.33.361 1.33 1.282v5.974a.24.24 0 00.267.248h1.366a.235.235 0 00.25-.248V9.516c0-1.795-.982-2.371-2.914-2.371z"
      fill-rule="evenodd"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-hello-sign" xmlns="http://www.w3.org/2000/svg">
    <g fill="#00B1E5" fill-rule="nonzero">
      <path
        d="M8.533 13.007L1 2h15.727L8.533 13.007zM5.63 4.435l2.984 4.362 3.25-4.362H5.63zM3 14h11v2H3z"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 400 400" id="rti-hibob" xmlns="http://www.w3.org/2000/svg">
    <g fill="#8AA2AD" fill-rule="evenodd">
      <path
        d="M209.15 272.8C182.6 272.8 161 250.93 161 224s21.59-48.75 48.14-48.75 48.14 21.87 48.14 48.75-21.6 48.76-48.14 48.76m0-82.21a33.45 33.45 0 1033 33.45 33.28 33.28 0 00-33-33.45M100.93 171.64A51.14 51.14 0 0071 181.33V138.4a11 11 0 10-22 0v85.87c0 29 23.31 52.55 51.93 52.55s51.93-23.6 51.93-52.59-23.3-52.59-51.93-52.59m-.37 82.46a30.06 30.06 0 1129.68-30.1 29.9 29.9 0 01-29.68 30.06M311 178.69c-15 0-28.26 7.53-37 19v-63.9a3.47 3.47 0 00-3.6-4.25 4.54 4.54 0 00-4.4 4.25V224h.21c0 25 20.1 45.32 44.78 45.32s44.78-20.34 44.78-45.35-20.09-45.28-44.77-45.28m0 82.21c-20.07 0-36.39-16.54-36.39-36.86s16.32-36.85 36.39-36.85 36.39 16.53 36.39 36.85S331.05 260.9 311 260.9"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-interview-mocha" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.257 9.626c.398 0 .698.358.634.751a8.056 8.056 0 01-6.616 6.617.645.645 0 01-.752-.635v-2.113c0-.298.2-.558.492-.625a4.694 4.694 0 003.504-3.504.64.64 0 01.624-.49zm-12.5-.002c.295 0 .555.202.624.491a4.698 4.698 0 003.504 3.504.64.64 0 01.491.625v2.113a.645.645 0 01-.751.634 8.056 8.056 0 01-6.616-6.616.645.645 0 01.634-.751zm6.416-8.521l.097.008a8.01 8.01 0 012.626.923 2.21 2.21 0 00-.346 1.317 2.231 2.231 0 003.42 1.758 8.01 8.01 0 01.923 2.626.642.642 0 01-.634.744h-2.113a.64.64 0 01-.625-.491 4.698 4.698 0 00-3.504-3.504.64.64 0 01-.491-.625V1.746a.64.64 0 01.744-.635zm-2.548.008a.645.645 0 01.751.635v2.113a.64.64 0 01-.491.625A4.694 4.694 0 004.38 7.988a.64.64 0 01-.625.49H1.643a.646.646 0 01-.634-.75A8.056 8.056 0 017.625 1.11zm7.236-.11a2.235 2.235 0 012.137 2.138 2.225 2.225 0 01-1.03 1.967 8.115 8.115 0 00-3.074-3.074 2.225 2.225 0 011.967-1.03z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-kununu" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.162 9.644l.276.276c.3.299.322.782.023 1.058l-2.184 2.115a.944.944 0 000 1.334l.368.368a.972.972 0 001.357 0l2.207-2.162c.3-.298.782-.275 1.081.023l.276.276a.757.757 0 01.023 1.058l-2.23 2.162a2.979 2.979 0 01-4.14.023l-.368-.345c-1.15-1.104-1.127-2.92.023-4.024l2.07-2.024.138-.138a.763.763 0 011.08 0zm9.084-.092l2.23 2.162c1.15 1.103 1.15 2.92.024 4.047l-.368.345c-1.15 1.127-2.99 1.104-4.14-.023l-2.07-2.024-.137-.138a.736.736 0 010-1.058l.276-.276c.299-.298.805-.321 1.104-.023l2.184 2.185a.972.972 0 001.357 0l.368-.345c.368-.368.391-.966 0-1.334l-2.208-2.161c-.299-.3-.276-.76.023-1.058l.276-.276a.786.786 0 011.081-.023zM6.358 1.848l2.07 2.024.138.138a.736.736 0 010 1.058l-.276.276c-.299.298-.805.321-1.104.023L5.002 3.205a.972.972 0 00-1.357 0l-.368.345a.944.944 0 000 1.334l2.207 2.161a.736.736 0 01-.023 1.058l-.276.276a.763.763 0 01-1.08 0L1.874 6.217C.724 5.114.724 3.297 1.851 2.17l.368-.345a2.979 2.979 0 014.14.023zm9.774-.023l.368.345c1.15 1.127 1.127 2.92 0 4.047l-2.07 2.024-.138.138a.763.763 0 01-1.08 0l-.277-.276c-.299-.299-.322-.782-.023-1.058l2.185-2.138c.368-.368.368-.966 0-1.311l-.368-.368a.972.972 0 00-1.357 0L11.165 5.39c-.3.298-.782.275-1.081-.023l-.276-.276a.757.757 0 01-.023-1.058l2.208-2.185c1.15-1.104 2.99-1.127 4.139-.023z"
      fill="#8AA2AD"
      fill-rule="nonzero"
    />
  </symbol>
  <symbol viewBox="0 0 190.85 194.5" id="rti-nmbrs" xmlns="http://www.w3.org/2000/svg">
    <g fill="#8AA2AD">
      <path
        d="M27.3 165.05V41.83h24.2L99 118.67V41.83h23.27v123.22h-20.7L50.76 83.58v81.47zM148.32 60.26c-9.07 0-13.66-7.34-13.66-14.76a16.1 16.1 0 012-8 12.88 12.88 0 0111.7-6.71 13 13 0 0112.45 8.53A19.43 19.43 0 01162 45.5a16.4 16.4 0 01-2 8 12 12 0 01-5.13 5.18 14.4 14.4 0 01-6.55 1.58zm0-3.15a9.37 9.37 0 006-2 9.83 9.83 0 003.38-4.66 16.12 16.12 0 00.87-5 13 13 0 00-1.47-6.24 10.1 10.1 0 00-15-3.28 9.37 9.37 0 00-3.34 4.7 17.07 17.07 0 00-.8 4.82c.04 6.05 3.59 11.66 10.4 11.66zm-5.73-3.91v-16h6.05c4.29 0 6.32 1.73 6.32 5a4.56 4.56 0 01-3.18 4.8l3.38 6.24h-3.94l-3.06-5.81h-1.83v5.77zm3.7-9.16h2.07c2 0 2.78-.4 2.78-1.94 0-1.26-.67-1.58-2.62-1.58h-2.23z"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-personio" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.422 9.575c-.616 2.188-1.123 4.025-1.164 4.274a.521.521 0 01-.522.456h-.058a.522.522 0 01-.459-.574c.023-.205.435-1.718.938-3.517-.711.331-1.296.545-1.657.59a1.322 1.322 0 01-.175.012c-.354 0-.531-.168-.62-.316a.52.52 0 01.682-.73c.31-.043 1.104-.368 2.148-.909.523-1.857 1.064-3.75 1.334-4.693a.522.522 0 011.003.286c-.32 1.12-.693 2.425-1.054 3.702.45-.26.927-.547 1.406-.858 2.607-1.683 4.383-3.292 4.741-4.317.135-.383.037-.56-.154-.707-.457-.354-1.861-.398-4.434.54C6.522 4.217 2.45 6.943 2.06 8.366c.04.007.08.011.12.01a.522.522 0 01.502.765.522.522 0 01-.454.276c-.11.005-.68.013-1.012-.38a.954.954 0 01-.186-.84c.26-1.215 1.92-2.544 3.265-3.452a27.724 27.724 0 015.728-2.911c1.84-.673 4.275-1.28 5.432-.385.54.421.735 1.023.551 1.705-.236.88-1.28 2.432-4.91 4.82a36.673 36.673 0 01-2.674 1.6zm8.746 6.414V17H2.178v-1.01h14.99z"
      fill="#8AA2AD"
      fill-rule="evenodd"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-predictive-index" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" fill-rule="nonzero" fill="none">
      <circle fill="#718497" cx="7.996" cy="7.996" r="7.996" />
      <path
        d="M9.844 4.693l.845.16v2.099c.371-.24.847-.247 1.226-.019V4.86a4.89 4.89 0 00.844-.185l.1-.034-.08-.672h-2.87l-.038.067a.757.757 0 00-.082.327c0 .15.007.22.027.267l.028.064z"
        fill="#FFF"
      />
      <circle fill="#FFF" cx="11.317" cy="7.932" r="1" />
      <path
        d="M12.878 11.303l-.963-.176V8.932a1.156 1.156 0 01-1.226-.019v2.207c-.291.035-.622.076-.88.165l-.1.034.07.705h3.032l.037-.067a.977.977 0 00.081-.37.59.59 0 00-.027-.219l-.024-.065zM8.569 4.505c-.443-.367-1.096-.538-2.057-.538H3.2l-.028.094a1.46 1.46 0 00-.07.525l.007.1.096.02c.256.056.5.093.764.127v6.31c-.062.008-.126.014-.192.02-.199.021-.406.041-.603.082l-.112.023.048.757H6.44l.019-.109a1.66 1.66 0 000-.54l-.016-.09-.09-.016a11.676 11.676 0 00-.811-.094c-.124-.012-.244-.023-.341-.034V9.22c.398.067.8.103 1.204.108 2.047 0 2.882-.826 2.882-2.85-.001-.927-.236-1.573-.718-1.972zm-.905 3.442c-.266.358-.725.526-1.448.525-.096 0-.199-.003-.302-.009l-.727-.041V4.906l.57-.009h.19c1.844 0 2.046.488 2.046 1.524 0 .757-.098 1.214-.329 1.526z"
        fill="#FFF"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-sign-request" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.013 10.112c-.431.748-2.968 1.711-2.968 1.711s-.165-2.526.266-3.274l3.9-6.767a1.558 1.558 0 012.13-.572 1.565 1.565 0 01.571 2.134l-3.9 6.768zm2.938-8.226a.779.779 0 00-1.065.287L9.987 8.94c-.216.374-.472 1.942-.472 1.942s1.607-.787 1.822-1.16l.004-.008 3.89-6.753.005-.008a.782.782 0 00-.285-1.067zM2.939 16.06h11.742V9h.94v7.059c0 .46-.48.941-.94.941H2.939C2.48 17 2 16.519 2 16.059V4.294c0-.46.48-.941.94-.941h6.575v.941H2.939V16.06z"
      fill="#3F72DA"
      fill-rule="nonzero"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-test-dome" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.441 13.12a.533.533 0 010-.057c.027-.266-.12-.597.064-.757.184-.16.491-.101.747-.13a24.504 24.504 0 002.595-.462c.141-.032.192-.077.184-.245a6.053 6.053 0 00-5.216-5.683 6.133 6.133 0 00-7.04 5.333c-.059.547-.059.534.474.664.932.213 1.878.363 2.83.448.2.016.282.086.266.3-.016.415 0 .834 0 1.252 0 .128 0 .211-.186.192a26.573 26.573 0 01-4.214-.74 1.115 1.115 0 01-.933-1.137C.796 8.431 3.49 4.962 7.122 4.202a7.947 7.947 0 018.845 4.112c.5.974.774 2.05.8 3.144.022.274.018.549-.014.821a1.067 1.067 0 01-.8.918 23.483 23.483 0 01-3.514.685c-.267.032-.518.037-.77.085-.182.032-.246 0-.236-.189.011-.19.008-.44.008-.659zM9.77 11.65v2.221c0 .2-.077.235-.266.232-.41 0-.824-.016-1.238 0-.229 0-.266-.082-.266-.28V9.525c0-.374 0-.376-.33-.21a2.63 2.63 0 00-1.233 1.263c-.064.136-.13.187-.267.165a46.74 46.74 0 00-1.333-.17c-.2-.024-.19-.115-.139-.267a4.44 4.44 0 018.376-.045c.086.24.048.31-.208.328-.38.03-.76.088-1.138.15a.344.344 0 01-.448-.23c-.256-.55-.7-.99-1.25-1.24-.188-.09-.268-.086-.268.157.016.744.008 1.485.008 2.224z"
      fill="#8AA2AD"
      fill-rule="evenodd"
    />
  </symbol>
  <symbol viewBox="0 0 18 18" id="rti-werken-in-een-hotel" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.99 14.683h-.804V4h.804v10.683zm-2.807 0h-.805V4h.805v10.683zm-2.615 0h-.805V11.07H7.228v3.621h-.805v-4.426h5.135v4.417h.01zm-6.956 0h-.805V4h.805v10.683zm-2.817 0H1V4h.805v10.683h-.01zm9.773-6.324H6.423V4h.805v3.554h3.525V4h.805v4.36h.01z"
      fill="#8AA2AD"
      fill-rule="nonzero"
    />
  </symbol>
  <symbol style="width: 24px; height: 24px" viewBox="0 0 24 24" id="scale-balance">
    <path
      d="M12 3c-1.27 0-2.4.8-2.82 2H3v2h1.95L2 14c-.47 2 1 3 3.5 3s4.06-1 3.5-3L6.05 7h3.12c.33.85.98 1.5 1.83 1.83V20H2v2h20v-2h-9V8.82c.85-.32 1.5-.97 1.82-1.82h3.13L15 14c-.47 2 1 3 3.5 3s4.06-1 3.5-3l-2.95-7H21V5h-6.17C14.4 3.8 13.27 3 12 3m0 2a1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1 1 1 0 011-1m-6.5 5.25L7 14H4l1.5-3.75m13 0L20 14h-3l1.5-3.75z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="search" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    />
  </symbol>
  <symbol fill="none" viewBox="0 0 14 18" id="security" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 .75l-6.75 3v4.5c0 4.162 2.88 8.055 6.75 9 3.87-.945 6.75-4.838 6.75-9v-4.5L7 .75zm0 8.242h5.25c-.398 3.09-2.46 5.843-5.25 6.705V9H1.75V4.725L7 2.393v6.6z"
      fill="#4D6072"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="send" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="settings" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0014 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="settings-backup-restore" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9a9 9 0 00-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7a6.995 6.995 0 01-11.06 5.7l-1.42 1.44A9 9 0 1012 3z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="share" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="short-text" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 9h16v2H4zm0 4h10v2H4z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="show-chart" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="sidemenu-acquisition" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 12v4a1 1 0 01-1 1c-.17 0-.33 0-.94-.5-.62-.5-1.67-1.5-2.75-2-1-.46-2.03-.5-3.05-.5l1.21 3.32.03.18a.5.5 0 01-.5.5H7c-.22 0-.41-.14-.47-.34L5.19 14H5a1 1 0 01-1-1 2 2 0 01-2-2 2 2 0 012-2 1 1 0 011-1h3c1.11 0 2.22 0 3.31-.5 1.08-.5 2.13-1.5 2.75-2 .61-.5.77-.5.94-.5a1 1 0 011 1v4a1 1 0 011 1 1 1 0 01-1 1m5-1c0 1.38-.56 2.63-1.46 3.54l-1.42-1.42a2.993 2.993 0 000-4.24l1.42-1.42C20.44 8.37 21 9.62 21 11z"
    />
  </symbol>
  <symbol viewBox="0 0 32 32" id="sidemenu-candidates" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="evenodd">
      <path
        d="M21.643 7H5.357C4.611 7 4 7.579 4 8.286v15.428C4 24.421 4.61 25 5.357 25h16.286c.746 0 1.357-.579 1.357-1.286V8.286C23 7.579 22.39 7 21.643 7zM13 11c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3zm6 12H7v-1c0-2 4-3 6-3s6 1 6 3v1zM26 25h2V7h-2z"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 32 32" id="sidemenu-dashboard" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="evenodd">
      <path
        d="M13.986 9.314C8.85 10.494 5 15.193 5 20.821V22h4.6v-2.358H7.369a9.489 9.489 0 011.863-4.598l1.575 1.615 1.622-1.662-1.576-1.627a9.054 9.054 0 014.497-1.91v2.287h2.3V11.46a9.054 9.054 0 014.496 1.91l-1.575 1.627 1.621 1.662 1.576-1.615a9.489 9.489 0 011.863 4.598H23.4V22H28v-1.179c0-5.706-3.956-10.457-9.2-11.554-2.504-.601-4.743.03-4.814.047z"
      />
      <path
        d="M19 20.623c0-.38-.088-.737-.262-1.046L16.5 15l-2.238 4.577c-.175.309-.262.665-.262 1.046C14 21.93 15.125 23 16.5 23s2.5-1.07 2.5-2.377"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 32 32" id="sidemenu-mailbox" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 8H8c-1.1 0-1.99.9-1.99 2L6 22c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 4l-8 5-8-5v-2l8 5 8-5v2z"
      fill-rule="evenodd"
    />
  </symbol>
  <symbol viewBox="0 0 32 32" id="sidemenu-offers" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="evenodd">
      <path
        d="M19 10h-5V8h5v2zm2 1V8l-2-2h-5l-2 2v3H7c-.976-.269-2 .784-2 2v9h23v-9c0-1.216-1.035-2.269-2-2h-5zM5 24h23v2H5z"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 32 32" id="sidemenu-reports" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="evenodd">
      <path
        d="M7.333 10H4.667c-.368 0-.667.326-.667.727v14.546c0 .401.299.727.667.727h2.666c.368 0 .667-.326.667-.727V10.727c0-.401-.299-.727-.667-.727zM13.611 15h-2.667c-.368 0-.944.04-.944.317v10c0 .276.576.683.944.683h2.667c.368 0 .389-.407.389-.683v-10c0-.277-.02-.317-.389-.317zM19.5 11h-2.667c-.368 0-.833.122-.833.499v13.636c0 .377.465.865.833.865H19.5c.368 0 .5-.488.5-.865V11.5c0-.377-.132-.499-.5-.499zM26.5 20.014h-2.667c-.368 0-.833-.065-.833.085v5.442c0 .15.465.459.833.459H26.5c.368 0 .5-.309.5-.46V20.1c0-.151-.132-.086-.5-.086z"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 32 32" id="sidemenu-settings" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(6 5)" fill-rule="evenodd">
      <path
        d="M10.5 16.435a5.022 5.022 0 100-10.044 5.022 5.022 0 000 10.044zm8.023-4.416c.043-.35.075-.7.075-1.062 0-.362-.032-.724-.075-1.096L20.8 8.075a.558.558 0 00.13-.701L18.77 3.583c-.13-.241-.421-.34-.658-.241l-2.688 1.095c-.562-.427-1.145-.8-1.825-1.073L13.201.46a.548.548 0 00-.54-.46H8.343a.548.548 0 00-.54.46l-.399 2.904c-.68.274-1.263.646-1.824 1.073L2.892 3.342a.527.527 0 00-.658.24L.074 7.375a.546.546 0 00.13.701l2.278 1.786a9.507 9.507 0 00-.076 1.096c0 .361.033.712.076 1.062L.204 13.84a.546.546 0 00-.13.7l2.16 3.791c.13.241.42.329.658.241l2.688-1.106c.561.438 1.144.81 1.824 1.084l.4 2.904c.043.263.27.46.54.46h4.317c.27 0 .497-.197.54-.46l.4-2.904a7.834 7.834 0 001.824-1.084l2.688 1.106c.237.088.528 0 .658-.24l2.159-3.792a.558.558 0 00-.13-.7l-2.277-1.82z"
      />
      <circle cx="10.5" cy="11.5" r="3.5" />
    </g>
  </symbol>
  <symbol viewBox="0 0 32 32" id="sidemenu-talent-pools" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(7 8)" fill-rule="evenodd">
      <rect y="11" width="5" height="5" rx="1" />
      <rect x="14" y="11" width="5" height="5" rx="1" />
      <rect x="7" width="5" height="5" rx="1" />
      <rect x="7" y="11" width="5" height="5" rx="1" />
      <path
        d="M4 9h4c0 .556.447 1 .999 1h1.002A.997.997 0 0011 9h4c0 .556.447 1 .999 1h1.002A.997.997 0 0018 9V8a1 1 0 00-1.006-1H11c0-.556-.447-1-.999-1H8.999A.997.997 0 008 7H1.996A.998.998 0 001 8v1c0 .556.447 1 .999 1h1.002A.997.997 0 004 9z"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="sidemenu-tasks" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
    />
  </symbol>
  <symbol viewBox="0 0 148 147" id="slack" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero" fill="none">
      <path
        d="M12.997 77.78c-5.494.042-10.148-3.232-11.864-8.342a13.67 13.67 0 01-.178-.583c-1.87-6.544 1.756-13.39 8.255-15.582L113.45 18.35a14.128 14.128 0 013.807-.556c5.64-.044 10.422 3.302 12.18 8.52l.156.504c1.95 6.816-2.895 12.9-8.7 14.85-.004.003-1.06.36-103.662 35.391a13.49 13.49 0 01-4.234.721z"
        fill="#70CADB"
      />
      <path
        d="M30.372 129.045c-5.537.04-10.207-3.188-11.903-8.225a13.34 13.34 0 01-.18-.579c-1.896-6.622 1.726-13.54 8.247-15.735L130.78 69.263c1.347-.45 2.738-.68 4.137-.693 5.552-.042 10.43 3.35 12.151 8.444l.16.53c1.007 3.521.412 7.478-1.59 10.601-1.492 2.322-6.198 4.366-6.198 4.366L34.8 128.29a14.356 14.356 0 01-4.428.757v-.002z"
        fill="#E01765"
      />
      <path
        d="M117.148 129.268a12.798 12.798 0 01-12.255-8.723l-34.79-103.34-.174-.58c-1.885-6.59 1.74-13.464 8.237-15.654 1.3-.437 2.644-.665 3.997-.677 2.01-.015 3.955.438 5.787 1.343a12.772 12.772 0 016.449 7.392l34.787 103.331.101.332c1.954 6.842-1.663 13.72-8.16 15.91a12.935 12.935 0 01-3.979.666z"
        fill="#E8A723"
      />
      <path
        d="M65.435 146.674a12.803 12.803 0 01-12.26-8.73L18.394 34.608a12.797 12.797 0 018.051-16.23 12.96 12.96 0 013.985-.668 12.796 12.796 0 0112.257 8.723l34.782 103.34a12.797 12.797 0 01-8.06 16.233 12.88 12.88 0 01-3.978.667h.004v.001z"
        fill="#3EB890"
      />
      <path fill="#CC2027" d="M99.997 105.996l24.258-8.294-7.93-23.55-24.286 8.207 7.958 23.637z" />
      <path fill="#361238" d="M48.364 123.65l24.256-8.293-7.99-23.73-24.28 8.21 8.014 23.813z" />
      <path fill="#65863A" d="M82.727 54.7l24.26-8.283-7.837-23.275-24.305 8.143z" />
      <path fill="#1A937D" d="M31.088 72.33l24.26-8.283-7.933-23.572-24.305 8.142 7.978 23.713z" />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="sms" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="sort" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="sort-ascending" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 11v2h8v-2h-8m0-6v2h4V5h-4m0 12v2h12v-2H10M6 7h2.5L5 3.5 1.5 7H4v13h2V7z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="sort-descending" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 13v-2h8v2h-8m0 6v-2h4v2h-4m0-12V5h12v2H10M6 17h2.5L5 20.5 1.5 17H4V4h2v13z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="stackexchange" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.728 15.577v1.036c0 1.754-1.395 3.177-3.1 3.177h-.904L13.645 24v-4.21H5.371c-1.704 0-3.099-1.423-3.099-3.181v-1.032h19.456zM2.275 10.463h19.323v3.979H2.275v-3.979zm0-5.141h19.323v3.979H2.275V5.322zM18.575 0c1.681 0 3.023 1.42 3.023 3.178v1.034H2.275V3.178C2.275 1.422 3.67 0 5.375 0h13.2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="stackoverflow" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.986 21.865v-6.404h2.134V24H1.844v-8.539h2.13v6.404h15.012zM6.111 19.731H16.85v-2.137H6.111v2.137zm.259-4.852l10.48 2.189.451-2.07-10.478-2.187-.453 2.068zm1.359-5.056l9.705 4.53.903-1.95-9.706-4.53-.902 1.936v.014zm2.715-4.785l8.217 6.855 1.359-1.62-8.216-6.853-1.35 1.617-.01.001zM15.751 0l-1.746 1.294 6.405 8.604 1.746-1.294L15.749 0h.002z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="star" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="star-border" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="star-half" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="subdirectory-arrow-right" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="subject" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="swap-horiz" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="sync" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0020 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 004 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="table-edit" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.7 13.35l-1 1-2.05-2.05 1-1c.21-.22.56-.22.77 0l1.28 1.28c.22.21.22.56 0 .77M12 18.94l6.07-6.06 2.05 2.05L14.06 21H12v-2.06M4 2h14a2 2 0 012 2v4.17L16.17 12H12v4.17L10.17 18H4a2 2 0 01-2-2V4a2 2 0 012-2m0 4v4h6V6H4m8 0v4h6V6h-6m-8 6v4h6v-4H4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="tag" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 7A1.5 1.5 0 014 5.5 1.5 1.5 0 015.5 4 1.5 1.5 0 017 5.5 1.5 1.5 0 015.5 7m15.91 4.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.11 0-2 .89-2 2v7c0 .55.22 1.05.59 1.41l8.99 9c.37.36.87.59 1.42.59.55 0 1.05-.23 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.56-.23-1.06-.59-1.42z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="tag-text-outline" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 7A1.5 1.5 0 007 5.5 1.5 1.5 0 005.5 4 1.5 1.5 0 004 5.5 1.5 1.5 0 005.5 7m15.91 4.58c.36.36.59.86.59 1.42 0 .55-.22 1.05-.59 1.41l-7 7c-.36.36-.86.59-1.41.59-.55 0-1.05-.23-1.42-.59l-8.99-9C2.22 12.05 2 11.55 2 11V4c0-1.11.89-2 2-2h7c.55 0 1.05.22 1.41.58l9 9M13 20l7-7-8.5-8.5-7 7L13 20M10.09 8.91L11.5 7.5 17 13l-1.41 1.41-5.5-5.5m-2.5 2.5L9 10l4 4-1.41 1.41-4-4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="talent-pools" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 2v6h2v3H5c-1.11 0-2 .89-2 2v3H1v6h6v-6H5v-3h6v3H9v6h6v-6h-2v-3h6v3h-2v6h6v-6h-2v-3c0-1.11-.89-2-2-2h-6V8h2V2H9z"
    />
  </symbol>
  <symbol viewBox="0 0 16 16" id="thumb-up" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.333 2l.307.287c.24.22.433.47.587.746a.567.567 0 01.053.403L9.5 6H13c1 0 1 1 1 1.5C14 9 13 11 12.5 12s-1.033 1-1.5 1H6.5c-.86 0-1.5-.718-1.5-1.5v-4c0-1 .5-1.375.5-1.375L9.333 2zM3 6a1 1 0 011 1v5a1 1 0 01-1 1H2V6h1z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="thumbs-up-down" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="timer-sand" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 2h12v6l-4 4 4 4v6H6v-6l4-4-4-4V2m10 14.5l-4-4-4 4V20h8v-3.5m-4-5l4-4V4H8v3.5l4 4M10 6h4v.75l-2 2-2-2V6z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="timetable" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 12h1.5v2.82l2.44 1.41-.75 1.3L14 15.69V12M4 2h14a2 2 0 012 2v6.1c1.24 1.26 2 2.99 2 4.9a7 7 0 01-7 7c-1.91 0-3.64-.76-4.9-2H4a2 2 0 01-2-2V4a2 2 0 012-2m0 13v3h4.67c-.43-.91-.67-1.93-.67-3H4m0-7h6V5H4v3m14 0V5h-6v3h6M4 13h4.29c.34-1.15.97-2.18 1.81-3H4v3m11-2.85A4.85 4.85 0 0010.15 15c0 2.68 2.17 4.85 4.85 4.85A4.85 4.85 0 0019.85 15c0-2.68-2.17-4.85-4.85-4.85z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="track-changes" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.07 4.93l-1.41 1.41A8.014 8.014 0 0120 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="translate" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0014.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
    />
  </symbol>
  <symbol
    style="width: 24px; height: 24px"
    viewBox="0 0 24 24"
    id="twitter"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 01-1.93.07 4.28 4.28 0 004 2.98 8.521 8.521 0 01-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="unarchive" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.55 5.22l-1.39-1.68A1.51 1.51 0 0018 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19a2 2 0 002 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z"
    />
  </symbol>
  <symbol viewBox="0 0 14 14" id="upgrade" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.684 0c3.32.33 5.965 2.958 6.28 6.288a6.995 6.995 0 01-6.28 7.663v-1.402c2.554-.302 4.561-2.328 4.884-4.88a5.605 5.605 0 00-4.884-6.253V0M6.28.021v1.402a5.612 5.612 0 00-2.736 1.178L2.54 1.563A6.9 6.9 0 016.28.021m-4.73 2.53l1.004 1.003a5.617 5.617 0 00-1.15 2.734H0a6.926 6.926 0 011.55-3.736M.008 7.69H1.41a5.607 5.607 0 001.144 2.734l-.996 1.002A7.035 7.035 0 01.007 7.691m3.537 3.764a5.618 5.618 0 002.736 1.143V14a7.017 7.017 0 01-3.74-1.584l1.004-.96m3.438-7.621L3.824 6.989h2.457v2.805h1.403V6.989h2.456L6.982 3.835z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="verified-user" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="videocam" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="view-column" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="view-stream" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 18h17v-6H4v6zM4 5v6h17V5H4z" />
  </symbol>
  <symbol viewBox="0 0 30 20" id="visa" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path
        d="M27 0H2C.816 0 0 .814 0 2v15c0 1.186.816 2 2 2h25c1.184 0 2-.814 2-2V2c0-1.186-.816-2-2-2z"
        fill="#FFF"
      />
      <path
        d="M27.273.455H1.818C.818.455 0 1.273 0 2.273V4.09h29.09V2.273c0-1-.817-1.818-1.817-1.818z"
        fill="#00357C"
      />
      <path
        d="M0 15.91v1.817c0 1 .818 1.818 1.818 1.818h25.455c1 0 1.818-.818 1.818-1.818V15.91H0z"
        fill="#FFB336"
      />
      <path
        d="M16.818 9.273c-.636-.364-1-.546-1-.91 0-.272.364-.636 1-.636.546 0 1 .091 1.364.273l.182.09.272-1.545c-.363-.181-.909-.272-1.545-.272-1.727 0-3 1-3 2.363 0 1 .909 1.546 1.545 1.91.728.363.91.545.91.909 0 .454-.546.727-1.091.727-.728 0-1.091-.091-1.637-.364l-.273-.09-.272 1.545a5.612 5.612 0 002 .363c1.818 0 3.09-.909 3.09-2.363 0-.91-.454-1.546-1.545-2zm6.273-2.818h-1.364c-.454 0-.727.09-.909.545l-2.636 6.455H20s.273-.91.364-1.091h2.272c.091.272.182 1.09.182 1.09h1.727l-1.454-7zM20.909 11c.182-.364.727-2 .727-2s.182-.364.273-.636L22 9s.364 1.636.364 2h-1.455zm-10.454 2.455h1.727l1.09-7h-1.727l-1.09 7zm-1.546-7l-1.727 4.818-.182-1c-.364-1.091-1.364-2.364-2.455-3l1.546 6.182H8l2.818-7H8.91z"
        fill="#00357C"
      />
      <path
        d="M6.364 7c-.091-.455-.455-.545-.819-.636H2.727v.181c2.182.546 3.728 2 4.273 3.728L6.364 7z"
        fill="#F1C40F"
      />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="visibility" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="visibility-off" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 001 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="vpn-key" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.65 10A5.99 5.99 0 007 6c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 005.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="warning" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="wc" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63A2.01 2.01 0 0016.56 7h-.12a2 2 0 00-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="work" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
    />
  </symbol>
  <symbol viewBox="0 0 24 24" id="xing" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.188 0c-.517 0-.741.325-.927.66 0 0-7.455 13.224-7.702 13.657.015.024 4.919 9.023 4.919 9.023.17.308.436.66.967.66h3.454c.211 0 .375-.078.463-.22.089-.151.089-.346-.009-.536l-4.879-8.916a.022.022 0 010-.022L22.139.756c.095-.191.097-.387.006-.535C22.056.078 21.894 0 21.686 0h-3.498zM3.648 4.74c-.211 0-.385.074-.473.216-.09.149-.078.339.02.531l2.34 4.05c.004.01.004.016 0 .021L1.86 16.051a.52.52 0 000 .529c.085.142.239.234.45.234h3.461c.518 0 .766-.348.945-.667l3.734-6.609-2.378-4.155c-.172-.315-.434-.659-.962-.659H3.648v.016z"
    />
  </symbol>
  <symbol viewBox="0 0 18 19" id="yahoo" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.377 4.424l-1.96.658c-.292.13-1.085 1.05-2.46 2.826-1.46 1.839-2.211 3.02-2.337 3.612l-.083 1.643-.042.984.168 2.496 2.585.065-.34 1.298H5.215l.15-1.166 1.209-.068c.627-.065 1.002-.196 1.127-.393.083-.13.124-.922.124-2.3v-.855l-.04-1.706c-.084-.392-.751-1.84-2.044-4.335-1.335-2.562-2.21-4.072-2.629-4.599L.693 2.06V.825h8.188l-.096 1.039-2.543.394c.792 1.838 2.002 4.398 3.628 7.618 2.128-2.562 3.254-4.204 3.295-4.925l-2.168-.526-.102-1.184h6.98l-.498 1.183z"
      fill-rule="nonzero"
      fill="#8aa2ad"
    />
  </symbol>
  <symbol
    viewBox="0 0 256 256"
    preserveAspectRatio="xMidYMid"
    id="zapier"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M159.999 128.056a76.55 76.55 0 01-4.915 27.024 76.745 76.745 0 01-27.032 4.923h-.108c-9.508-.012-18.618-1.75-27.024-4.919A76.557 76.557 0 0196 128.056v-.112a76.598 76.598 0 014.91-27.02A76.492 76.492 0 01127.945 96h.108a76.475 76.475 0 0127.032 4.923 76.51 76.51 0 014.915 27.02v.112zm94.223-21.389h-74.716l52.829-52.833a128.518 128.518 0 00-13.828-16.349v-.004a129 129 0 00-16.345-13.816l-52.833 52.833V1.782A128.606 128.606 0 00128.064 0h-.132c-7.248.004-14.347.62-21.265 1.782v74.716L53.834 23.665A127.82 127.82 0 0037.497 37.49l-.028.02A128.803 128.803 0 0023.66 53.834l52.837 52.833H1.782S0 120.7 0 127.956v.088c0 7.256.615 14.367 1.782 21.289h74.716l-52.837 52.833a128.91 128.91 0 0030.173 30.173l52.833-52.837v74.72a129.3 129.3 0 0021.24 1.778h.181a129.15 129.15 0 0021.24-1.778v-74.72l52.838 52.837a128.994 128.994 0 0016.341-13.82l.012-.012a129.245 129.245 0 0013.816-16.341l-52.837-52.833h74.724c1.163-6.91 1.77-14 1.778-21.24v-.186c-.008-7.24-.615-14.33-1.778-21.24z"
      fill="#FF4A00"
    />
  </symbol>
  <symbol
    id="zoom-us"
    viewBox="0 0 650 338.1"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>
      .mfst6 {
        fill: #fefefe;
      }
      .mfst25 {
        fill: #2d8bfe;
      }
      .mfst26 {
        fill: #4599fe;
      }
      .mfst27 {
        fill: #5aa4fe;
      }
      .mfst28 {
        fill: #98c7fe;
      }
      .mfst29 {
        fill: #98c6fe;
      }
      .mfst30 {
        fill: #f9f8f7;
      }
      .mfst31 {
        fill: #f7f6f5;
      }
      .mfst32 {
        fill: #faf9f8;
      }
      .mfst33 {
        fill: #fcfcfb;
      }
      .mfst34 {
        fill: #fbfbfa;
      }
      .mfst35 {
        fill: #fbfaf9;
      }
      .mfst36 {
        fill: #f5f3f1;
      }
      .mfst37 {
        fill: #f5f4f2;
      }
      .mfst38 {
        fill: #f6f5f3;
      }
      .mfst39 {
        fill: #fdfdfd;
      }
      .mfst40 {
        fill: #f6f4f3;
      }
      .mfst41 {
        fill: #f9f9f9;
      }
      .mfst42 {
        fill: #2779dc;
      }
      .mfst43 {
        fill: #2c88f9;
      }
    </style>
    <path
      class="mfst25"
      d="M259.6 123v.6c-.1.2-.1.4 0 .6v1.2c-.2.4-.2.8 0 1.2v1.5c-.2.4-.2.8 0 1.2v1.7c-.2 1.4-.2 2.7-.3 4.1-.3 3.1-1.2 6.1-2.3 9.1-2.1 5.7-5.1 11-9.2 15.6-3.9 4.4-8.3 8.1-13.4 10.9-4.3 2.4-8.9 4.2-13.7 5.2-2 .4-4 .4-6 .6-.2 0-.5-.1-.7.1h-.6c-.2-.1-.4-.1-.6 0h-1.4c-.3-.2-.6-.2-1 0h-.8c-.4-.2-.8-.2-1.2 0h-1.2c-.2-.1-.4-.1-.6 0h-.8c-1.4-.2-2.7-.2-4.1-.3-3.2-.3-6.2-1.2-9.2-2.3-5.2-1.9-9.9-4.6-14.1-8.1-5.2-4.3-9.5-9.3-12.6-15.2-2.4-4.5-4.1-9.2-5.1-14.2-.3-1.4-.3-2.7-.4-4.1-.2-4.7-.3-9.3.3-14 .5-4.2 1.9-8.2 3.7-12.1 2-4.4 4.5-8.5 7.8-12.1 4-4.5 8.6-8.4 13.9-11.2 4.5-2.4 9.3-4.2 14.3-5.2 1.4-.3 2.8-.3 4.2-.4 4.6-.2 9.3-.3 13.9.3 4.2.5 8.1 1.9 11.9 3.6 4.5 2 8.7 4.6 12.4 7.9 4.6 4.1 8.5 8.7 11.3 14.2 2.1 4.1 3.8 8.3 4.8 12.8.4 2 .4 4.1.6 6.1.1.2 0 .5.2.7z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst26"
      d="M259.6 126.5c-.2-.4-.3-.8 0-1.2v1.2z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst27"
      d="M259.6 129.2c-.3-.4-.2-.8 0-1.2v1.2z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst26"
      d="M208.5 176.5c.4-.3.8-.3 1.2 0h-1.2zM210.4 176.5c.3-.2.6-.3 1 0h-1z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst28"
      d="M259.6 124.2c-.2-.2-.3-.4 0-.6v.6z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst29"
      d="M206.7 176.5c.2-.3.4-.2.6 0h-.6zM212.7 176.5c.2-.2.4-.3.6 0h-.6z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst30"
      d="M213.5 113.4c2.3.3 4.2 1.3 5.6 3.2.5 1.1-.1 2.1-.7 2.9-.6.9-1.1 1.9-1.6 2.8-1.6 3.1-3.3 6.2-5 9.2-1.6 2.7-3 5.5-4.6 8.3-.3.5-.5 1.1-1.2 1.2h-8c-.8-.1-.6-.6-.4-1.1 1.1-2.3 2.2-4.6 3.6-6.7 1.8-2.8 3-5.8 4.8-8.6 1-1.6 1.7-3.4 2.7-5 .9-1.6 1.9-3.2 2.7-4.9.5-.8 1.2-1.3 2.1-1.3z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst31"
      d="M206.3 140.8c.4-1.5 1.3-2.7 2-4 .7-1.4 1.4-2.8 2.2-4.2 1-1.6 1.9-3.3 2.8-4.9 1.3-2.5 2.7-4.9 4-7.4.7-1.2 1.4-2.4 1.8-3.8 1.3 1.4 1.9 3.2 2.1 5.1.2 2.3.2 4.7.1 7-.8 2.1-2.1 3.8-3.1 5.8-1 1.9-2 3.9-3 5.8-.2.3-.3.8-.8.7h-7.1c-.3.1-.7.2-1-.1z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst32"
      d="M213.5 113.4c-.9.2-1.3.9-1.7 1.6-2.3 4.1-4.5 8.2-6.8 12.3-.7 1.3-1.3 2.8-2.1 4.1-1.3 2.1-2.5 4.2-3.6 6.3-.5 1-1.1 2-1.5 3.1-.9.3-1.9.1-2.8.1-.5-.2-1 0-1.5-.3-.4 0-.8 0-1.1-.2-.4-.5-.2-1 .1-1.3 1.4-1.6 2.1-3.6 3.1-5.4 1.4-2.5 2.7-5 4.1-7.5.8-1.4 1.5-2.8 2.3-4.2 1.5-2.7 2.9-5.3 4.5-8 .2-.4.6-.8 1.1-.8 1.5.1 2.9-.1 4.4.1.5.1 1 .1 1.5.1z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst33"
      d="M185.8 135.6c-.7-1-.6-2.2-1-3.3-.3-.4-.1-.9-.1-1.4.2-.6.1-1.2.1-1.8-.1-2.8.9-5.1 2.5-7.3.6-.9 1-1.9 1.4-2.8.7-1.6 1.9-2.9 2.5-4.6.3-.9 1.3-1.2 2.3-1.1h4.5c.5 0 .5.4.5.8 0 .5-.2 1-.4 1.4-1.6 2.7-3 5.5-4.6 8.3-1 1.8-2.1 3.7-3 5.6-.2.4-.5.8-.7 1.1-1.2 1.5-1.7 3.5-2.9 5-.3.2-.6.7-1.1.1z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst34"
      d="M185.8 135.6c.3.1.4-.1.6-.3 1.5-2.5 2.9-5.1 4.3-7.6 1.1-1.9 2-3.9 3.2-5.7 1.1-1.8 2-3.8 3.1-5.7.6-1 1.1-1.9 1.3-3 1.6-.2 3.2 0 4.7-.1.8.2.6.7.3 1.1-1.7 2.6-2.8 5.4-4.4 8-1.4 2.3-2.5 4.9-3.9 7.2-1.4 2.4-2.6 4.9-4.1 7.2-.4.5-.4 1.2-.8 1.7-.3.4-.6.6-1.1.7-1.5-.8-2.6-1.9-3.2-3.5z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst35"
      d="M188.9 139.2c1.3-2.2 2.6-4.5 3.9-6.7.9-1.5 1.7-3 2.6-4.5.7-1.2 1.3-2.5 1.9-3.7 1.3-2.5 2.8-4.9 4-7.4.6-1.2 1.4-2.3 1.9-3.5 1.4-.2 2.7-.2 4.1 0-1 2-2.2 3.9-3.2 5.8-.9 1.7-1.8 3.3-2.7 5-2.4 4.1-4.6 8.3-6.8 12.4-.7 1.3-1.8 2.5-2.2 3.9-1.3-.1-2.5-.5-3.5-1.3z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst36"
      d="M235.2 140.1c-.5.8-1.1.7-1.7.3-1.5-1.1-2.9-2.2-4.3-3.3-.6-.5-1.4-.9-1.9-1.5-.1-.4 0-.8.2-1.2l4.8-8.7c.6-1.2 1.3-2.3 1.9-3.5.4-.7.8-.8 1.2-.1v17c-.1.3 0 .6-.2 1z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst37"
      d="M235.2 121.7c-1 .6-1.1 1.7-1.7 2.6-1.3 1.9-2.2 4.1-3.5 6.1-.9 1.4-1.6 3.1-2.4 4.6-.1.2-.3.4-.4.5-1.1-.8-2.3-1.5-3.2-2.5 0-.2 0-.4.1-.6.8-1 1.1-2.2 1.7-3.3.9-1.5 1.7-3.2 2.6-4.7.9-1.5 1.6-3.1 2.5-4.6.9-1.6 1.7-3.3 2.7-4.9.3-.5.4-1.2 1.2-1.2.1.1.2.3.4.4.1 2.5.2 5.1 0 7.6z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst38"
      d="M234.9 113.7c-1.9 3.5-3.8 7-5.8 10.5-1.4 2.5-2.8 4.9-4 7.4-.2.4-.4.8-.9.9-.3-.3-.2-.7-.2-1V122c0-.6.1-1 .6-1.4 1.9-1.5 3.8-2.9 5.7-4.4.3-.2.6-.4.8-.8.7-.6 1.4-1.1 2.2-1.7.5-.3 1-.4 1.6 0z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst39"
      d="M193.2 113.4c-1 0-1.4.7-1.7 1.5-.3.9-.8 1.6-1.2 2.4-.9 1.4-1.5 2.8-2.2 4.2-.4.9-1 1.7-1.5 2.5-1 1.6-1.5 3.4-1.5 5.3 0 .5.1 1-.2 1.5-.2-.2-.1-.4-.1-.6v-16.1c0-.2 0-.3.1-.5.1-.4.3-.4.6-.4h7.7c.1 0 .1.1 0 .2z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst40"
      d="M214.7 140.8c-.1-.8.4-1.4.7-2.1 1.7-2.9 2.9-6 4.9-8.7.3-.5.2-1.3 1-1.4.1 4.1.1 8.1 0 12.2-.5.3-1.1.1-1.7.1-1.7 0-3.3.2-4.9-.1z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst41"
      d="M231.1 115.5c-.2.9-1 1.2-1.6 1.7-1.4 1.1-2.8 2.2-4.3 3.3-.7.5-1.1 1.1-1.1 2.1.1 3.3 0 6.7 0 10-.1.1-.1.3-.2.4-.2-.2-.2-.5-.2-.7v-10.4c0-.5.1-.9.5-1.2 2.4-1.8 4.7-3.5 6.9-5.2z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst42"
      d="M214.7 140.8h6.6c-.3.3-.7.2-1.1.2h-25.7c-.3 0-.7.2-.8-.2.4-.1.9-.1 1.3 0H214.7z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst43"
      d="M235.2 121.7v-7.6c.2.3.2.7.2 1v24.1c0 .3.2.6-.2.8v-18.3zM184.8 113.6v18.7c-.3-.3-.2-.7-.2-1.1v-16.6c0-.4 0-.7.2-1z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst6"
      d="M193.2 113.4v-.2h18.3c.2 0 .4 0 .5.2h-18.8z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
    <path
      class="mfst30"
      d="M194.9 140.8h-1.3c0-.1 0-.1-.1-.1.5 0 1-.1 1.4.1z"
      transform="matrix(6 0 0 6 -940 -600)"
    />
  </symbol>
</svg>
